/* tslint:disable */
/* eslint-disable */
/**
 * Musicgram
 * The musicgram API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AcceptAndPayRequestDto
 */
export interface AcceptAndPayRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AcceptAndPayRequestDto
     */
    method: AcceptAndPayRequestDtoMethodEnum;
    /**
     * Return URL for Moneta widget flow
     * @type {string}
     * @memberof AcceptAndPayRequestDto
     */
    returnUrl?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AcceptAndPayRequestDtoMethodEnum {
    Card = 'card',
    Sbp = 'sbp'
}

/**
 * 
 * @export
 * @interface Ad
 */
export interface Ad {
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    ownerId: string;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    backgroundImageId: string;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    startDate: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    dueDate: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ad
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof Ad
     */
    isArchived: boolean;
    /**
     * 
     * @type {Array<Specialization>}
     * @memberof Ad
     */
    specializations?: Array<Specialization>;
    /**
     * 
     * @type {BackgroundImage}
     * @memberof Ad
     */
    backgroundImage?: BackgroundImage;
    /**
     * 
     * @type {User}
     * @memberof Ad
     */
    owner?: User;
    /**
     * 
     * @type {Array<ExecutionRequest>}
     * @memberof Ad
     */
    proposals: Array<ExecutionRequest>;
    /**
     * 
     * @type {Array<Deal>}
     * @memberof Ad
     */
    deals: Array<Deal>;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof Ad
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface AdFromMeResponseDto
 */
export interface AdFromMeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdFromMeResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdFromMeResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdFromMeResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdFromMeResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdFromMeResponseDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AdFromMeResponseDto
     */
    startDate: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdFromMeResponseDto
     */
    dueDate: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdFromMeResponseDto
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof AdFromMeResponseDto
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdFromMeResponseDto
     */
    isArchived: boolean;
    /**
     * 
     * @type {Array<SpecializationFromAdResponseDto>}
     * @memberof AdFromMeResponseDto
     */
    specializations: Array<SpecializationFromAdResponseDto>;
    /**
     * 
     * @type {BackgroundImageResponseDto}
     * @memberof AdFromMeResponseDto
     */
    backgroundImage: BackgroundImageResponseDto;
}
/**
 * 
 * @export
 * @interface AdFromUserResponseDto
 */
export interface AdFromUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdFromUserResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdFromUserResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdFromUserResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdFromUserResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdFromUserResponseDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AdFromUserResponseDto
     */
    startDate: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdFromUserResponseDto
     */
    dueDate: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdFromUserResponseDto
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof AdFromUserResponseDto
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdFromUserResponseDto
     */
    isArchived: boolean;
    /**
     * 
     * @type {Array<SpecializationFromAdResponseDto>}
     * @memberof AdFromUserResponseDto
     */
    specializations: Array<SpecializationFromAdResponseDto>;
    /**
     * 
     * @type {BackgroundImageResponseDto}
     * @memberof AdFromUserResponseDto
     */
    backgroundImage: BackgroundImageResponseDto;
}
/**
 * 
 * @export
 * @interface Admin
 */
export interface Admin {
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof Admin
     */
    email: string;
}
/**
 * 
 * @export
 * @interface AdminDisputeResponseDto
 */
export interface AdminDisputeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminDisputeResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDisputeResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDisputeResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDisputeResponseDto
     */
    isResolved: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminDisputeResponseDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDisputeResponseDto
     */
    initiatorId: string;
    /**
     * 
     * @type {UserResponseDto}
     * @memberof AdminDisputeResponseDto
     */
    initiator: UserResponseDto;
    /**
     * 
     * @type {DealWithRelationsDto}
     * @memberof AdminDisputeResponseDto
     */
    deal: DealWithRelationsDto;
    /**
     * External ID of successful payment operation in Moneta related to the deal
     * @type {string}
     * @memberof AdminDisputeResponseDto
     */
    paymentOperationExternalId?: string | null;
}
/**
 * 
 * @export
 * @interface AdminGetComplaintsResponseDto
 */
export interface AdminGetComplaintsResponseDto {
    /**
     * 
     * @type {Array<ComplaintResponseDto>}
     * @memberof AdminGetComplaintsResponseDto
     */
    data: Array<ComplaintResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof AdminGetComplaintsResponseDto
     */
    currentPage: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetComplaintsResponseDto
     */
    perPage: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetComplaintsResponseDto
     */
    totalPages: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetComplaintsResponseDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface AdminGetDisputesResponseDto
 */
export interface AdminGetDisputesResponseDto {
    /**
     * 
     * @type {Array<AdminDisputeResponseDto>}
     * @memberof AdminGetDisputesResponseDto
     */
    data: Array<AdminDisputeResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof AdminGetDisputesResponseDto
     */
    currentPage: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetDisputesResponseDto
     */
    perPage: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetDisputesResponseDto
     */
    totalPages: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetDisputesResponseDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetDisputesResponseDto
     */
    page: number;
}
/**
 * 
 * @export
 * @interface AdminGetUserResponseDto
 */
export interface AdminGetUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminGetUserResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminGetUserResponseDto
     */
    nickname: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminGetUserResponseDto
     */
    isBlocked: boolean;
    /**
     * 
     * @type {AdminProfileFromUserResponseDto}
     * @memberof AdminGetUserResponseDto
     */
    profile: AdminProfileFromUserResponseDto;
}
/**
 * 
 * @export
 * @interface AdminGetUsersResponseDto
 */
export interface AdminGetUsersResponseDto {
    /**
     * 
     * @type {Array<AdminGetUserResponseDto>}
     * @memberof AdminGetUsersResponseDto
     */
    data: Array<AdminGetUserResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof AdminGetUsersResponseDto
     */
    currentPage: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetUsersResponseDto
     */
    perPage: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetUsersResponseDto
     */
    totalPages: number;
    /**
     * 
     * @type {number}
     * @memberof AdminGetUsersResponseDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface AdminNotification
 */
export interface AdminNotification {
    /**
     * 
     * @type {string}
     * @memberof AdminNotification
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotification
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotification
     */
    notificationTitle: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotification
     */
    notificationBody: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotification
     */
    administratorSenderId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotification
     */
    sentAt: string;
    /**
     * 
     * @type {Admin}
     * @memberof AdminNotification
     */
    administrator?: Admin;
    /**
     * 
     * @type {string}
     * @memberof AdminNotification
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotification
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotification
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface AdminNotificationHistoryResponseDto
 */
export interface AdminNotificationHistoryResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminNotificationHistoryResponseDto
     */
    data: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AdminNotificationHistoryResponseDto
     */
    currentPage: number;
    /**
     * 
     * @type {number}
     * @memberof AdminNotificationHistoryResponseDto
     */
    perPage: number;
    /**
     * 
     * @type {number}
     * @memberof AdminNotificationHistoryResponseDto
     */
    totalPages: number;
    /**
     * 
     * @type {number}
     * @memberof AdminNotificationHistoryResponseDto
     */
    total: number;
}
/**
 * 
 * @export
 * @interface AdminNotificationResponseDto
 */
export interface AdminNotificationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminNotificationResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotificationResponseDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotificationResponseDto
     */
    notificationTitle: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotificationResponseDto
     */
    notificationBody: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNotificationResponseDto
     */
    administratorSenderId: string;
}
/**
 * 
 * @export
 * @interface AdminPaymentOperationSummaryDto
 */
export interface AdminPaymentOperationSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentOperationSummaryDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentOperationSummaryDto
     */
    type: AdminPaymentOperationSummaryDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentOperationSummaryDto
     */
    status: AdminPaymentOperationSummaryDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentOperationSummaryDto
     */
    externalId: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminPaymentOperationSummaryDto
     */
    amountMinor: number;
    /**
     * 
     * @type {string}
     * @memberof AdminPaymentOperationSummaryDto
     */
    createdAt: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AdminPaymentOperationSummaryDtoTypeEnum {
    Payment = 'payment',
    Payout = 'payout'
}
/**
    * @export
    * @enum {string}
    */
export enum AdminPaymentOperationSummaryDtoStatusEnum {
    Created = 'created',
    Pending = 'pending',
    Succeeded = 'succeeded',
    Failed = 'failed',
    Canceled = 'canceled'
}

/**
 * 
 * @export
 * @interface AdminProfileFromUserResponseDto
 */
export interface AdminProfileFromUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminProfileFromUserResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProfileFromUserResponseDto
     */
    avatarUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminProfileFromUserResponseDto
     */
    deepLink: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminProfileFromUserResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProfileFromUserResponseDto
     */
    surname: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminProfileFromUserResponseDto
     */
    website: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProfileFromUserResponseDto
     */
    verified: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminProfileFromUserResponseDto
     */
    priority: number;
}
/**
 * 
 * @export
 * @interface AdminResolveDisputeCustomerResponseDto
 */
export interface AdminResolveDisputeCustomerResponseDto {
    /**
     * 
     * @type {AdminDisputeResponseDto}
     * @memberof AdminResolveDisputeCustomerResponseDto
     */
    dispute: AdminDisputeResponseDto;
    /**
     * 
     * @type {Array<AdminPaymentOperationSummaryDto>}
     * @memberof AdminResolveDisputeCustomerResponseDto
     */
    paymentOperations: Array<AdminPaymentOperationSummaryDto>;
}
/**
 * 
 * @export
 * @interface AdminResolveDisputeExecutorResponseDto
 */
export interface AdminResolveDisputeExecutorResponseDto {
    /**
     * 
     * @type {AdminDisputeResponseDto}
     * @memberof AdminResolveDisputeExecutorResponseDto
     */
    dispute: AdminDisputeResponseDto;
}
/**
 * 
 * @export
 * @interface AdminUpdateProfileRequestDto
 */
export interface AdminUpdateProfileRequestDto {
    /**
     * URL of the profile\'s avatar
     * @type {string}
     * @memberof AdminUpdateProfileRequestDto
     */
    avatarUrl?: string | null;
    /**
     * Deep link of the profile
     * @type {string}
     * @memberof AdminUpdateProfileRequestDto
     */
    deepLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateProfileRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateProfileRequestDto
     */
    surname?: string;
    /**
     * Profile\'s website
     * @type {string}
     * @memberof AdminUpdateProfileRequestDto
     */
    website?: string | null;
    /**
     * UUIDv4 of the profile\'s background image
     * @type {string}
     * @memberof AdminUpdateProfileRequestDto
     */
    backgroundImageId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateProfileRequestDto
     */
    verified?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateProfileRequestDto
     */
    priority: number;
}
/**
 * 
 * @export
 * @interface AdminUpdateProfileResponseDto
 */
export interface AdminUpdateProfileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateProfileResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateProfileResponseDto
     */
    nickname: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateProfileResponseDto
     */
    isBlocked: boolean;
    /**
     * 
     * @type {AdminProfileFromUserResponseDto}
     * @memberof AdminUpdateProfileResponseDto
     */
    profile: AdminProfileFromUserResponseDto;
}
/**
 * 
 * @export
 * @interface AdminUpdateUserProfileRequestDto
 */
export interface AdminUpdateUserProfileRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateUserProfileRequestDto
     */
    nickname?: string;
    /**
     * 
     * @type {AdminUpdateProfileRequestDto}
     * @memberof AdminUpdateUserProfileRequestDto
     */
    profile?: AdminUpdateProfileRequestDto;
}
/**
 * 
 * @export
 * @interface AppMedia
 */
export interface AppMedia {
    /**
     * 
     * @type {string}
     * @memberof AppMedia
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AppMedia
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AppMedia
     */
    kind: AppMediaKindEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AppMedia
     */
    isActive: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AppMedia
     */
    s3Key: string;
    /**
     * 
     * @type {string}
     * @memberof AppMedia
     */
    s3Link: string;
    /**
     * 
     * @type {string}
     * @memberof AppMedia
     */
    iconUserId?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum AppMediaKindEnum {
    MainPageFirstVideo = 'mainPageFirstVideo',
    MainPageSecondVideo = 'mainPageSecondVideo',
    MainPageFirstBanner = 'mainPageFirstBanner',
    MainPageSecondBanner = 'mainPageSecondBanner'
}

/**
 * 
 * @export
 * @interface AuthResponseDto
 */
export interface AuthResponseDto {
    /**
     * 
     * @type {UserResponseDto}
     * @memberof AuthResponseDto
     */
    user: UserResponseDto;
    /**
     * 
     * @type {TokensResponseDto}
     * @memberof AuthResponseDto
     */
    tokens: TokensResponseDto;
}
/**
 * 
 * @export
 * @interface BackgroundImage
 */
export interface BackgroundImage {
    /**
     * 
     * @type {string}
     * @memberof BackgroundImage
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BackgroundImage
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof BackgroundImage
     */
    type: BackgroundImageTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum BackgroundImageTypeEnum {
    Profile = 'profile',
    Ad = 'ad',
    Category = 'category',
    Specialization = 'specialization'
}

/**
 * 
 * @export
 * @interface BackgroundImageResponseDto
 */
export interface BackgroundImageResponseDto {
    /**
     * 
     * @type {string}
     * @memberof BackgroundImageResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BackgroundImageResponseDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof BackgroundImageResponseDto
     */
    type: BackgroundImageResponseDtoTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum BackgroundImageResponseDtoTypeEnum {
    Profile = 'profile',
    Ad = 'ad',
    Category = 'category',
    Specialization = 'specialization'
}

/**
 * 
 * @export
 * @interface BlockOrUnblockUserRequestDto
 */
export interface BlockOrUnblockUserRequestDto {
    /**
     * 
     * @type {string}
     * @memberof BlockOrUnblockUserRequestDto
     */
    reason: string | null;
}
/**
 * 
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    smallBackgroundImageUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    backgroundImageUrl: string | null;
    /**
     * 
     * @type {Array<CategorySpecialization>}
     * @memberof Category
     */
    specializations?: Array<CategorySpecialization>;
}
/**
 * 
 * @export
 * @interface CategoryResponseDto
 */
export interface CategoryResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CategoryResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponseDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponseDto
     */
    smallBackgroundImageUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof CategoryResponseDto
     */
    backgroundImageUrl: string | null;
    /**
     * 
     * @type {Array<SpecializationResponseDto>}
     * @memberof CategoryResponseDto
     */
    specializations: Array<SpecializationResponseDto>;
}
/**
 * 
 * @export
 * @interface CategorySpecialization
 */
export interface CategorySpecialization {
    /**
     * 
     * @type {string}
     * @memberof CategorySpecialization
     */
    id: string;
    /**
     * 
     * @type {Specialization}
     * @memberof CategorySpecialization
     */
    specialization: Specialization;
    /**
     * 
     * @type {Category}
     * @memberof CategorySpecialization
     */
    category: Category;
    /**
     * 
     * @type {string}
     * @memberof CategorySpecialization
     */
    specializationId: string;
    /**
     * 
     * @type {string}
     * @memberof CategorySpecialization
     */
    categoryId: string;
}
/**
 * 
 * @export
 * @interface CompanionResponseDto
 */
export interface CompanionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CompanionResponseDto
     */
    joinedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CompanionResponseDto
     */
    leftAt: string | null;
    /**
     * 
     * @type {ProfileFromCompanionResponseDto}
     * @memberof CompanionResponseDto
     */
    profile: ProfileFromCompanionResponseDto;
    /**
     * 
     * @type {string}
     * @memberof CompanionResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CompanionResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CompanionResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanionResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanionResponseDto
     */
    nickname: string;
}
/**
 * 
 * @export
 * @interface Complaint
 */
export interface Complaint {
    /**
     * 
     * @type {string}
     * @memberof Complaint
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof Complaint
     */
    checked: boolean;
    /**
     * 
     * @type {string}
     * @memberof Complaint
     */
    checkedAt: string;
    /**
     * 
     * @type {string}
     * @memberof Complaint
     */
    fromUserId: string;
    /**
     * 
     * @type {string}
     * @memberof Complaint
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof Complaint
     */
    reason: string;
    /**
     * 
     * @type {User}
     * @memberof Complaint
     */
    fromUser: User;
    /**
     * 
     * @type {User}
     * @memberof Complaint
     */
    toUser: User;
    /**
     * 
     * @type {string}
     * @memberof Complaint
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Complaint
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof Complaint
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface ComplaintResponseDto
 */
export interface ComplaintResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ComplaintResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ComplaintResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ComplaintResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ComplaintResponseDto
     */
    checkedAt: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ComplaintResponseDto
     */
    checked: boolean;
    /**
     * 
     * @type {UserResponseDto}
     * @memberof ComplaintResponseDto
     */
    fromUser: UserResponseDto;
    /**
     * 
     * @type {UserResponseDto}
     * @memberof ComplaintResponseDto
     */
    toUser: UserResponseDto;
    /**
     * 
     * @type {string}
     * @memberof ComplaintResponseDto
     */
    reason: string;
}
/**
 * 
 * @export
 * @interface CreateAdRequestDto
 */
export interface CreateAdRequestDto {
    /**
     * Title of the ad. Max 60 characters-long.
     * @type {string}
     * @memberof CreateAdRequestDto
     */
    title: string;
    /**
     * Url of the chosen background.
     * @type {string}
     * @memberof CreateAdRequestDto
     */
    backgroundImageId: string;
    /**
     * Start date of the ad. Can be null if the due date set.
     * @type {string}
     * @memberof CreateAdRequestDto
     */
    startDate?: string | null;
    /**
     * Due date of the ad. Can be null if the start date set.
     * @type {string}
     * @memberof CreateAdRequestDto
     */
    dueDate?: string | null;
    /**
     * Price/salary for the ad.
     * @type {number}
     * @memberof CreateAdRequestDto
     */
    price: number;
    /**
     * Description of the ad. Max 700 characters-long.
     * @type {string}
     * @memberof CreateAdRequestDto
     */
    description: string;
    /**
     * Specialization\'s ids for the ad.
     * @type {Array<string>}
     * @memberof CreateAdRequestDto
     */
    specializationIds: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateAdResponseDto
 */
export interface CreateAdResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAdResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAdResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdResponseDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAdResponseDto
     */
    startDate: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAdResponseDto
     */
    dueDate: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateAdResponseDto
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof CreateAdResponseDto
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAdResponseDto
     */
    isArchived: boolean;
    /**
     * 
     * @type {Array<SpecializationFromAdResponseDto>}
     * @memberof CreateAdResponseDto
     */
    specializations: Array<SpecializationFromAdResponseDto>;
    /**
     * 
     * @type {BackgroundImageResponseDto}
     * @memberof CreateAdResponseDto
     */
    backgroundImage: BackgroundImageResponseDto;
    /**
     * 
     * @type {UserResponseDto}
     * @memberof CreateAdResponseDto
     */
    owner: UserResponseDto;
}
/**
 * 
 * @export
 * @interface CreateChatRequestDto
 */
export interface CreateChatRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateChatRequestDto
     */
    userId: string;
    /**
     * 
     * @type {InitialMessageRequestDto}
     * @memberof CreateChatRequestDto
     */
    initialMessage: InitialMessageRequestDto;
}
/**
 * 
 * @export
 * @interface CreateChatResponseDto
 */
export interface CreateChatResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateChatResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateChatResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateChatResponseDto
     */
    id: string;
    /**
     * 
     * @type {CompanionResponseDto}
     * @memberof CreateChatResponseDto
     */
    companion: CompanionResponseDto;
    /**
     * 
     * @type {LastReadMessageResponseDto}
     * @memberof CreateChatResponseDto
     */
    lastReadMessage: LastReadMessageResponseDto;
    /**
     * 
     * @type {LastMessageResponseDto}
     * @memberof CreateChatResponseDto
     */
    lastMessage: LastMessageResponseDto | null;
    /**
     * 
     * @type {number}
     * @memberof CreateChatResponseDto
     */
    unreadMessagesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateChatResponseDto
     */
    banned: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateChatResponseDto
     */
    bannedByMe: boolean;
}
/**
 * 
 * @export
 * @interface CreateComplaintRequestDto
 */
export interface CreateComplaintRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateComplaintRequestDto
     */
    toUserId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateComplaintRequestDto
     */
    reason: string;
}
/**
 * 
 * @export
 * @interface CreateComplaintResponseDto
 */
export interface CreateComplaintResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateComplaintResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateComplaintResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateComplaintResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateComplaintResponseDto
     */
    checkedAt: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateComplaintResponseDto
     */
    checked: boolean;
    /**
     * 
     * @type {UserResponseDto}
     * @memberof CreateComplaintResponseDto
     */
    fromUser: UserResponseDto;
    /**
     * 
     * @type {UserResponseDto}
     * @memberof CreateComplaintResponseDto
     */
    toUser: UserResponseDto;
    /**
     * 
     * @type {string}
     * @memberof CreateComplaintResponseDto
     */
    reason: string;
}
/**
 * 
 * @export
 * @interface CreateExecutionRequestDto
 */
export interface CreateExecutionRequestDto {
    /**
     * Ad ID for which the request is made
     * @type {string}
     * @memberof CreateExecutionRequestDto
     */
    adId: string;
    /**
     * Message for the request (1-760 characters)
     * @type {string}
     * @memberof CreateExecutionRequestDto
     */
    message: string;
}
/**
 * 
 * @export
 * @interface CreateNotificationRequestDto
 */
export interface CreateNotificationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateNotificationRequestDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNotificationRequestDto
     */
    notificationTitle: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNotificationRequestDto
     */
    notificationText: string;
}
/**
 * 
 * @export
 * @interface CreateProfileRequestDto
 */
export interface CreateProfileRequestDto {
    /**
     * URL of the profile\'s avatar
     * @type {string}
     * @memberof CreateProfileRequestDto
     */
    avatarUrl?: string | null;
    /**
     * Deep link of the profile
     * @type {string}
     * @memberof CreateProfileRequestDto
     */
    deepLink?: string | null;
    /**
     * Profile\'s name
     * @type {string}
     * @memberof CreateProfileRequestDto
     */
    name: string;
    /**
     * Profile\'s surname
     * @type {string}
     * @memberof CreateProfileRequestDto
     */
    surname?: string;
    /**
     * Short profile\'s description
     * @type {string}
     * @memberof CreateProfileRequestDto
     */
    shortDescription: string | null;
    /**
     * Full profile\'s description
     * @type {string}
     * @memberof CreateProfileRequestDto
     */
    fullDescription: string | null;
    /**
     * Profile\'s website
     * @type {string}
     * @memberof CreateProfileRequestDto
     */
    website?: string | null;
    /**
     * User\'s specializations
     * @type {Array<string>}
     * @memberof CreateProfileRequestDto
     */
    specializationIds: Array<string> | null;
    /**
     * UUIDv4 of the profile\'s background image
     * @type {string}
     * @memberof CreateProfileRequestDto
     */
    backgroundImageId: string;
}
/**
 * 
 * @export
 * @interface CreateProfileResponseDto
 */
export interface CreateProfileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateProfileResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfileResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfileResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateProfileResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfileResponseDto
     */
    nickname: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProfileResponseDto
     */
    isBlocked: boolean;
    /**
     * 
     * @type {ProfileResponseDto}
     * @memberof CreateProfileResponseDto
     */
    profile: ProfileResponseDto;
    /**
     * 
     * @type {string}
     * @memberof CreateProfileResponseDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfileResponseDto
     */
    email: string | null;
}
/**
 * 
 * @export
 * @interface Cursor
 */
export interface Cursor {
    /**
     * 
     * @type {string}
     * @memberof Cursor
     */
    beforeCursor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Cursor
     */
    afterCursor: string | null;
    /**
     * 
     * @type {number}
     * @memberof Cursor
     */
    total?: number;
}
/**
 * 
 * @export
 * @interface Deal
 */
export interface Deal {
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    adId: string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    executionRequestId: string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    status: DealStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    createdAt: string;
    /**
     * 
     * @type {Ad}
     * @memberof Deal
     */
    ad: Ad;
    /**
     * 
     * @type {ExecutionRequest}
     * @memberof Deal
     */
    executionRequest: ExecutionRequest;
    /**
     * 
     * @type {Array<Dispute>}
     * @memberof Deal
     */
    disputes: Array<Dispute>;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof Deal
     */
    deletedAt: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum DealStatusEnum {
    AwaitingPayment = 'awaiting_payment',
    InProgress = 'in_progress',
    Completed = 'completed',
    Cancelled = 'cancelled',
    Dispute = 'dispute',
    SubmittedForReview = 'submitted_for_review',
    ReadyForPayment = 'ready_for_payment'
}

/**
 * 
 * @export
 * @interface DealAdDto
 */
export interface DealAdDto {
    /**
     * Ad ID
     * @type {string}
     * @memberof DealAdDto
     */
    id: string;
    /**
     * Ad title
     * @type {string}
     * @memberof DealAdDto
     */
    title: string;
    /**
     * Ad price
     * @type {number}
     * @memberof DealAdDto
     */
    price: number;
    /**
     * Ad description
     * @type {string}
     * @memberof DealAdDto
     */
    description: string;
    /**
     * Ad owner information
     * @type {DealAdOwnerDto}
     * @memberof DealAdDto
     */
    owner: DealAdOwnerDto;
}
/**
 * 
 * @export
 * @interface DealAdOwnerDto
 */
export interface DealAdOwnerDto {
    /**
     * User ID
     * @type {string}
     * @memberof DealAdOwnerDto
     */
    id: string;
    /**
     * User email
     * @type {string}
     * @memberof DealAdOwnerDto
     */
    email: string;
    /**
     * User nickname
     * @type {string}
     * @memberof DealAdOwnerDto
     */
    nickname: string;
    /**
     * User phone
     * @type {string}
     * @memberof DealAdOwnerDto
     */
    phone: string;
    /**
     * User blocked status
     * @type {boolean}
     * @memberof DealAdOwnerDto
     */
    isBlocked: boolean;
    /**
     * User profile information
     * @type {DealUserProfileDto}
     * @memberof DealAdOwnerDto
     */
    profile?: DealUserProfileDto;
}
/**
 * 
 * @export
 * @interface DealExecutionRequestDto
 */
export interface DealExecutionRequestDto {
    /**
     * Execution request ID
     * @type {string}
     * @memberof DealExecutionRequestDto
     */
    id: string;
    /**
     * Execution request message
     * @type {string}
     * @memberof DealExecutionRequestDto
     */
    message: string | null;
    /**
     * Execution request status
     * @type {string}
     * @memberof DealExecutionRequestDto
     */
    status: DealExecutionRequestDtoStatusEnum;
    /**
     * Execution request user information
     * @type {DealExecutionRequestUserDto}
     * @memberof DealExecutionRequestDto
     */
    user: DealExecutionRequestUserDto;
}

/**
    * @export
    * @enum {string}
    */
export enum DealExecutionRequestDtoStatusEnum {
    Pending = 'pending',
    Accepted = 'accepted',
    Rejected = 'rejected'
}

/**
 * 
 * @export
 * @interface DealExecutionRequestUserDto
 */
export interface DealExecutionRequestUserDto {
    /**
     * User ID
     * @type {string}
     * @memberof DealExecutionRequestUserDto
     */
    id: string;
    /**
     * User email
     * @type {string}
     * @memberof DealExecutionRequestUserDto
     */
    email: string;
    /**
     * User phone
     * @type {string}
     * @memberof DealExecutionRequestUserDto
     */
    phone: string;
    /**
     * User profile information
     * @type {DealUserProfileDto}
     * @memberof DealExecutionRequestUserDto
     */
    profile?: DealUserProfileDto;
}
/**
 * 
 * @export
 * @interface DealUserProfileDto
 */
export interface DealUserProfileDto {
    /**
     * Profile ID
     * @type {string}
     * @memberof DealUserProfileDto
     */
    id: string;
    /**
     * User name
     * @type {string}
     * @memberof DealUserProfileDto
     */
    name: string;
    /**
     * User surname
     * @type {string}
     * @memberof DealUserProfileDto
     */
    surname?: string;
    /**
     * User nickname
     * @type {string}
     * @memberof DealUserProfileDto
     */
    nickname?: string;
    /**
     * Profile avatar URL
     * @type {string}
     * @memberof DealUserProfileDto
     */
    avatarUrl?: string;
    /**
     * Short description
     * @type {string}
     * @memberof DealUserProfileDto
     */
    shortDescription?: string;
    /**
     * Full description
     * @type {string}
     * @memberof DealUserProfileDto
     */
    fullDescription?: string;
    /**
     * Website URL
     * @type {string}
     * @memberof DealUserProfileDto
     */
    website?: string;
    /**
     * Deep link
     * @type {string}
     * @memberof DealUserProfileDto
     */
    deepLink?: string;
}
/**
 * 
 * @export
 * @interface DealWithRelationsDto
 */
export interface DealWithRelationsDto {
    /**
     * Deal ID
     * @type {string}
     * @memberof DealWithRelationsDto
     */
    id: string;
    /**
     * Ad ID
     * @type {string}
     * @memberof DealWithRelationsDto
     */
    adId: string;
    /**
     * Execution request ID
     * @type {string}
     * @memberof DealWithRelationsDto
     */
    executionRequestId: string | null;
    /**
     * Deal status
     * @type {string}
     * @memberof DealWithRelationsDto
     */
    status: DealWithRelationsDtoStatusEnum;
    /**
     * Deal creation date
     * @type {string}
     * @memberof DealWithRelationsDto
     */
    createdAt: string;
    /**
     * Deal update date
     * @type {string}
     * @memberof DealWithRelationsDto
     */
    updatedAt: string;
    /**
     * Deal deletion date
     * @type {string}
     * @memberof DealWithRelationsDto
     */
    deletedAt: string | null;
    /**
     * Ad information
     * @type {DealAdDto}
     * @memberof DealWithRelationsDto
     */
    ad: DealAdDto;
    /**
     * Execution request information
     * @type {DealExecutionRequestDto}
     * @memberof DealWithRelationsDto
     */
    executionRequest?: DealExecutionRequestDto;
}

/**
    * @export
    * @enum {string}
    */
export enum DealWithRelationsDtoStatusEnum {
    AwaitingPayment = 'awaiting_payment',
    InProgress = 'in_progress',
    Completed = 'completed',
    Cancelled = 'cancelled',
    Dispute = 'dispute',
    SubmittedForReview = 'submitted_for_review',
    ReadyForPayment = 'ready_for_payment'
}

/**
 * 
 * @export
 * @interface Dispute
 */
export interface Dispute {
    /**
     * 
     * @type {string}
     * @memberof Dispute
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Dispute
     */
    dealId: string;
    /**
     * 
     * @type {string}
     * @memberof Dispute
     */
    initiatorId: string;
    /**
     * 
     * @type {string}
     * @memberof Dispute
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof Dispute
     */
    isResolved: boolean;
    /**
     * 
     * @type {string}
     * @memberof Dispute
     */
    monetaOperationId: string | null;
    /**
     * 
     * @type {string}
     * @memberof Dispute
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Dispute
     */
    updatedAt: string;
    /**
     * 
     * @type {Deal}
     * @memberof Dispute
     */
    deal: Deal;
    /**
     * 
     * @type {User}
     * @memberof Dispute
     */
    initiator: User;
    /**
     * 
     * @type {string}
     * @memberof Dispute
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface ExecutionRequest
 */
export interface ExecutionRequest {
    /**
     * 
     * @type {string}
     * @memberof ExecutionRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionRequest
     */
    userId: string;
    /**
     * 
     * @type {User}
     * @memberof ExecutionRequest
     */
    user: User;
    /**
     * 
     * @type {string}
     * @memberof ExecutionRequest
     */
    adId: string;
    /**
     * 
     * @type {Ad}
     * @memberof ExecutionRequest
     */
    ad: Ad;
    /**
     * 
     * @type {string}
     * @memberof ExecutionRequest
     */
    message: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExecutionRequest
     */
    status: ExecutionRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ExecutionRequest
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ExecutionRequest
     */
    updatedAt: string;
    /**
     * 
     * @type {Array<Deal>}
     * @memberof ExecutionRequest
     */
    deals: Array<Deal>;
}

/**
    * @export
    * @enum {string}
    */
export enum ExecutionRequestStatusEnum {
    Pending = 'pending',
    Accepted = 'accepted',
    Rejected = 'rejected'
}

/**
 * 
 * @export
 * @interface ExecutionRequestResponseDto
 */
export interface ExecutionRequestResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ExecutionRequestResponseDto
     */
    dealId: string;
}
/**
 * 
 * @export
 * @interface FavoriteUser
 */
export interface FavoriteUser {
    /**
     * 
     * @type {string}
     * @memberof FavoriteUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteUser
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof FavoriteUser
     */
    favUserId: string;
    /**
     * 
     * @type {User}
     * @memberof FavoriteUser
     */
    user?: User;
    /**
     * 
     * @type {User}
     * @memberof FavoriteUser
     */
    favUser?: User;
}
/**
 * 
 * @export
 * @interface FieldValidationErrorFromUpdateUserDto
 */
export interface FieldValidationErrorFromUpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof FieldValidationErrorFromUpdateUserDto
     */
    field: FieldValidationErrorFromUpdateUserDtoFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FieldValidationErrorFromUpdateUserDto
     */
    type: FieldValidationErrorFromUpdateUserDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FieldValidationErrorFromUpdateUserDto
     */
    message: string;
}

/**
    * @export
    * @enum {string}
    */
export enum FieldValidationErrorFromUpdateUserDtoFieldEnum {
    Nickname = 'nickname'
}
/**
    * @export
    * @enum {string}
    */
export enum FieldValidationErrorFromUpdateUserDtoTypeEnum {
    NicknameIsUsed = 'NICKNAME_IS_USED'
}

/**
 * 
 * @export
 * @interface GetAdResponseDto
 */
export interface GetAdResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetAdResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetAdResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetAdResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAdResponseDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof GetAdResponseDto
     */
    startDate: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAdResponseDto
     */
    dueDate: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetAdResponseDto
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof GetAdResponseDto
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAdResponseDto
     */
    isArchived: boolean;
    /**
     * 
     * @type {Array<SpecializationFromAdResponseDto>}
     * @memberof GetAdResponseDto
     */
    specializations: Array<SpecializationFromAdResponseDto>;
    /**
     * 
     * @type {BackgroundImageResponseDto}
     * @memberof GetAdResponseDto
     */
    backgroundImage: BackgroundImageResponseDto;
    /**
     * 
     * @type {UserResponseDto}
     * @memberof GetAdResponseDto
     */
    owner: UserResponseDto;
    /**
     * Chat ID for communication with ad owner
     * @type {string}
     * @memberof GetAdResponseDto
     */
    chatId?: string;
    /**
     * Whether the ad owner is banned
     * @type {boolean}
     * @memberof GetAdResponseDto
     */
    banned?: boolean;
    /**
     * Whether the ad owner is banned by current user
     * @type {boolean}
     * @memberof GetAdResponseDto
     */
    bannedByMe?: boolean;
}
/**
 * 
 * @export
 * @interface GetBackgroundImagesResponseDto
 */
export interface GetBackgroundImagesResponseDto {
    /**
     * 
     * @type {Array<BackgroundImageResponseDto>}
     * @memberof GetBackgroundImagesResponseDto
     */
    data: Array<BackgroundImageResponseDto>;
    /**
     * 
     * @type {Cursor}
     * @memberof GetBackgroundImagesResponseDto
     */
    cursor: Cursor;
}
/**
 * 
 * @export
 * @interface GetCategoriesResponseDto
 */
export interface GetCategoriesResponseDto {
    /**
     * 
     * @type {Array<CategoryResponseDto>}
     * @memberof GetCategoriesResponseDto
     */
    data: Array<CategoryResponseDto>;
}
/**
 * 
 * @export
 * @interface GetCategoryResponseDto
 */
export interface GetCategoryResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetCategoryResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryResponseDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryResponseDto
     */
    smallBackgroundImageUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetCategoryResponseDto
     */
    backgroundImageUrl: string | null;
    /**
     * 
     * @type {Array<SpecializationResponseDto>}
     * @memberof GetCategoryResponseDto
     */
    specializations: Array<SpecializationResponseDto>;
}
/**
 * 
 * @export
 * @interface GetChatResponseDto
 */
export interface GetChatResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetChatResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetChatResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetChatResponseDto
     */
    id: string;
    /**
     * 
     * @type {CompanionResponseDto}
     * @memberof GetChatResponseDto
     */
    companion: CompanionResponseDto;
    /**
     * 
     * @type {LastReadMessageResponseDto}
     * @memberof GetChatResponseDto
     */
    lastReadMessage: LastReadMessageResponseDto;
    /**
     * 
     * @type {LastMessageResponseDto}
     * @memberof GetChatResponseDto
     */
    lastMessage: LastMessageResponseDto | null;
    /**
     * 
     * @type {number}
     * @memberof GetChatResponseDto
     */
    unreadMessagesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetChatResponseDto
     */
    banned: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetChatResponseDto
     */
    bannedByMe: boolean;
}
/**
 * 
 * @export
 * @interface GetChatsPaginatedResponseDto
 */
export interface GetChatsPaginatedResponseDto {
    /**
     * 
     * @type {Array<GetMyChatResponseDto>}
     * @memberof GetChatsPaginatedResponseDto
     */
    data: Array<GetMyChatResponseDto>;
    /**
     * 
     * @type {Cursor}
     * @memberof GetChatsPaginatedResponseDto
     */
    cursor: Cursor;
}
/**
 * 
 * @export
 * @interface GetDealByIdDto
 */
export interface GetDealByIdDto {
    /**
     * Deal information with relations
     * @type {DealWithRelationsDto}
     * @memberof GetDealByIdDto
     */
    deal: DealWithRelationsDto;
    /**
     * Original request message from execution request
     * @type {string}
     * @memberof GetDealByIdDto
     */
    requestMessage?: string | null;
    /**
     * Chat ID for communication between deal participants
     * @type {string}
     * @memberof GetDealByIdDto
     */
    chatId?: string;
}
/**
 * 
 * @export
 * @interface GetExecutionRequestResponseDto
 */
export interface GetExecutionRequestResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetExecutionRequestResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetExecutionRequestResponseDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof GetExecutionRequestResponseDto
     */
    adId: string;
    /**
     * 
     * @type {string}
     * @memberof GetExecutionRequestResponseDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof GetExecutionRequestResponseDto
     */
    status: GetExecutionRequestResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetExecutionRequestResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetExecutionRequestResponseDto
     */
    updatedAt: string;
    /**
     * Chat ID for communication between executor and ad owner
     * @type {string}
     * @memberof GetExecutionRequestResponseDto
     */
    chatId?: string;
    /**
     * 
     * @type {GetUserResponseDto}
     * @memberof GetExecutionRequestResponseDto
     */
    user: GetUserResponseDto;
    /**
     * 
     * @type {GetAdResponseDto}
     * @memberof GetExecutionRequestResponseDto
     */
    ad: GetAdResponseDto;
}

/**
    * @export
    * @enum {string}
    */
export enum GetExecutionRequestResponseDtoStatusEnum {
    Pending = 'pending',
    Accepted = 'accepted',
    Rejected = 'rejected'
}

/**
 * 
 * @export
 * @interface GetFollowerResponseDto
 */
export interface GetFollowerResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetFollowerResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetFollowerResponseDto
     */
    nickname: string;
    /**
     * 
     * @type {ProfileFromFollowerResponseDto}
     * @memberof GetFollowerResponseDto
     */
    profile: ProfileFromFollowerResponseDto;
}
/**
 * 
 * @export
 * @interface GetFollowersResponseDto
 */
export interface GetFollowersResponseDto {
    /**
     * 
     * @type {Array<GetFollowerResponseDto>}
     * @memberof GetFollowersResponseDto
     */
    data: Array<GetFollowerResponseDto>;
    /**
     * 
     * @type {Cursor}
     * @memberof GetFollowersResponseDto
     */
    cursor: Cursor;
}
/**
 * 
 * @export
 * @interface GetManyAdminNotificationResponseDto
 */
export interface GetManyAdminNotificationResponseDto {
    /**
     * 
     * @type {Array<AdminNotification>}
     * @memberof GetManyAdminNotificationResponseDto
     */
    data: Array<AdminNotification>;
    /**
     * 
     * @type {number}
     * @memberof GetManyAdminNotificationResponseDto
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyAdminNotificationResponseDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyAdminNotificationResponseDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyAdminNotificationResponseDto
     */
    pageCount: number;
}
/**
 * 
 * @export
 * @interface GetManyComplaintResponseDto
 */
export interface GetManyComplaintResponseDto {
    /**
     * 
     * @type {Array<Complaint>}
     * @memberof GetManyComplaintResponseDto
     */
    data: Array<Complaint>;
    /**
     * 
     * @type {number}
     * @memberof GetManyComplaintResponseDto
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyComplaintResponseDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyComplaintResponseDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyComplaintResponseDto
     */
    pageCount: number;
}
/**
 * 
 * @export
 * @interface GetManyDisputeResponseDto
 */
export interface GetManyDisputeResponseDto {
    /**
     * 
     * @type {Array<Dispute>}
     * @memberof GetManyDisputeResponseDto
     */
    data: Array<Dispute>;
    /**
     * 
     * @type {number}
     * @memberof GetManyDisputeResponseDto
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyDisputeResponseDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyDisputeResponseDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyDisputeResponseDto
     */
    pageCount: number;
}
/**
 * 
 * @export
 * @interface GetManyUserResponseDto
 */
export interface GetManyUserResponseDto {
    /**
     * 
     * @type {Array<User>}
     * @memberof GetManyUserResponseDto
     */
    data: Array<User>;
    /**
     * 
     * @type {number}
     * @memberof GetManyUserResponseDto
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyUserResponseDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyUserResponseDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof GetManyUserResponseDto
     */
    pageCount: number;
}
/**
 * 
 * @export
 * @interface GetMeResponseDto
 */
export interface GetMeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetMeResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetMeResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetMeResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetMeResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetMeResponseDto
     */
    nickname: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetMeResponseDto
     */
    isBlocked: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetMeResponseDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof GetMeResponseDto
     */
    email: string | null;
    /**
     * 
     * @type {ProfileFromMeResponseDto}
     * @memberof GetMeResponseDto
     */
    profile: ProfileFromMeResponseDto;
    /**
     * 
     * @type {Array<AdFromMeResponseDto>}
     * @memberof GetMeResponseDto
     */
    ads: Array<AdFromMeResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof GetMeResponseDto
     */
    followers: number;
    /**
     * 
     * @type {number}
     * @memberof GetMeResponseDto
     */
    following: number;
}
/**
 * 
 * @export
 * @interface GetMessageFromMessages
 */
export interface GetMessageFromMessages {
    /**
     * 
     * @type {string}
     * @memberof GetMessageFromMessages
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetMessageFromMessages
     */
    chatId: string;
    /**
     * 
     * @type {string}
     * @memberof GetMessageFromMessages
     */
    senderId: string;
    /**
     * 
     * @type {string}
     * @memberof GetMessageFromMessages
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof GetMessageFromMessages
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetMessageFromMessages
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetMessageFromMessages
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface GetMessagesPaginatedResponseDto
 */
export interface GetMessagesPaginatedResponseDto {
    /**
     * 
     * @type {Array<GetMessageFromMessages>}
     * @memberof GetMessagesPaginatedResponseDto
     */
    data: Array<GetMessageFromMessages>;
    /**
     * 
     * @type {Cursor}
     * @memberof GetMessagesPaginatedResponseDto
     */
    cursor: Cursor;
}
/**
 * 
 * @export
 * @interface GetMyChatResponseDto
 */
export interface GetMyChatResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetMyChatResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyChatResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetMyChatResponseDto
     */
    id: string;
    /**
     * 
     * @type {CompanionResponseDto}
     * @memberof GetMyChatResponseDto
     */
    companion: CompanionResponseDto;
    /**
     * 
     * @type {LastReadMessageResponseDto}
     * @memberof GetMyChatResponseDto
     */
    lastReadMessage: LastReadMessageResponseDto;
    /**
     * 
     * @type {LastMessageResponseDto}
     * @memberof GetMyChatResponseDto
     */
    lastMessage: LastMessageResponseDto | null;
    /**
     * 
     * @type {number}
     * @memberof GetMyChatResponseDto
     */
    unreadMessagesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetMyChatResponseDto
     */
    banned: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetMyChatResponseDto
     */
    bannedByMe: boolean;
}
/**
 * 
 * @export
 * @interface GetPaginatedAdResponseDto
 */
export interface GetPaginatedAdResponseDto {
    /**
     * 
     * @type {Array<GetAdResponseDto>}
     * @memberof GetPaginatedAdResponseDto
     */
    data: Array<GetAdResponseDto>;
    /**
     * 
     * @type {Cursor}
     * @memberof GetPaginatedAdResponseDto
     */
    cursor: Cursor;
}
/**
 * 
 * @export
 * @interface GetSpecializationResponseDto
 */
export interface GetSpecializationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetSpecializationResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetSpecializationResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetSpecializationResponseDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof GetSpecializationResponseDto
     */
    smallBackgroundImageUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSpecializationResponseDto
     */
    backgroundImageUrl: string | null;
}
/**
 * 
 * @export
 * @interface GetSpecializationsResponseDto
 */
export interface GetSpecializationsResponseDto {
    /**
     * 
     * @type {Array<SpecializationResponseDto>}
     * @memberof GetSpecializationsResponseDto
     */
    data: Array<SpecializationResponseDto>;
}
/**
 * 
 * @export
 * @interface GetUserFcmsResponseDto
 */
export interface GetUserFcmsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetUserFcmsResponseDto
     */
    deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserFcmsResponseDto
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserFcmsResponseDto
     */
    userId: string;
}
/**
 * 
 * @export
 * @interface GetUserNotificationsSettingsRequestDto
 */
export interface GetUserNotificationsSettingsRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof GetUserNotificationsSettingsRequestDto
     */
    disabled?: boolean;
}
/**
 * 
 * @export
 * @interface GetUserResponseDto
 */
export interface GetUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    nickname: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponseDto
     */
    isBlocked: boolean;
    /**
     * 
     * @type {ProfileFromUserResponseDto}
     * @memberof GetUserResponseDto
     */
    profile: ProfileFromUserResponseDto;
    /**
     * 
     * @type {Array<AdFromUserResponseDto>}
     * @memberof GetUserResponseDto
     */
    ads: Array<AdFromUserResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof GetUserResponseDto
     */
    chatId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponseDto
     */
    banned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserResponseDto
     */
    bannedByMe?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetUserResponseDto
     */
    followers: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserResponseDto
     */
    following: number;
}
/**
 * 
 * @export
 * @interface GetUserWithFcmsResponseDto
 */
export interface GetUserWithFcmsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetUserWithFcmsResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserWithFcmsResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserWithFcmsResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserWithFcmsResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetUserWithFcmsResponseDto
     */
    nickname: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserWithFcmsResponseDto
     */
    isBlocked: boolean;
    /**
     * 
     * @type {ProfileFromUserResponseDto}
     * @memberof GetUserWithFcmsResponseDto
     */
    profile: ProfileFromUserResponseDto;
    /**
     * 
     * @type {Array<AdFromUserResponseDto>}
     * @memberof GetUserWithFcmsResponseDto
     */
    ads: Array<AdFromUserResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof GetUserWithFcmsResponseDto
     */
    chatId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserWithFcmsResponseDto
     */
    banned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetUserWithFcmsResponseDto
     */
    bannedByMe?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetUserWithFcmsResponseDto
     */
    followers: number;
    /**
     * 
     * @type {number}
     * @memberof GetUserWithFcmsResponseDto
     */
    following: number;
    /**
     * 
     * @type {Array<GetUserFcmsResponseDto>}
     * @memberof GetUserWithFcmsResponseDto
     */
    fcms: Array<GetUserFcmsResponseDto>;
}
/**
 * 
 * @export
 * @interface GetUsersResponseDto
 */
export interface GetUsersResponseDto {
    /**
     * 
     * @type {Array<UserFromUsersResponseDto>}
     * @memberof GetUsersResponseDto
     */
    data: Array<UserFromUsersResponseDto>;
    /**
     * 
     * @type {Cursor}
     * @memberof GetUsersResponseDto
     */
    cursor: Cursor;
}
/**
 * 
 * @export
 * @interface InitPayoutRequestDto
 */
export interface InitPayoutRequestDto {
    /**
     * 
     * @type {string}
     * @memberof InitPayoutRequestDto
     */
    method: InitPayoutRequestDtoMethodEnum;
    /**
     * Card number for card payouts
     * @type {string}
     * @memberof InitPayoutRequestDto
     */
    recipientHint?: string;
    /**
     * Card expiration date in MM/YYYY format (required for card payouts)
     * @type {string}
     * @memberof InitPayoutRequestDto
     */
    cardExpiration?: string;
    /**
     * Recipient phone (required for SBP payouts)
     * @type {string}
     * @memberof InitPayoutRequestDto
     */
    phone?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum InitPayoutRequestDtoMethodEnum {
    Card = 'card',
    Sbp = 'sbp'
}

/**
 * 
 * @export
 * @interface InitialMessageRequestDto
 */
export interface InitialMessageRequestDto {
    /**
     * 
     * @type {string}
     * @memberof InitialMessageRequestDto
     */
    content: string;
}
/**
 * 
 * @export
 * @interface LastMessageResponseDto
 */
export interface LastMessageResponseDto {
    /**
     * 
     * @type {string}
     * @memberof LastMessageResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LastMessageResponseDto
     */
    chatId: string;
    /**
     * 
     * @type {string}
     * @memberof LastMessageResponseDto
     */
    senderId: string;
    /**
     * 
     * @type {string}
     * @memberof LastMessageResponseDto
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof LastMessageResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LastMessageResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof LastMessageResponseDto
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface LastReadMessageResponseDto
 */
export interface LastReadMessageResponseDto {
    /**
     * 
     * @type {string}
     * @memberof LastReadMessageResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LastReadMessageResponseDto
     */
    chatId: string;
    /**
     * 
     * @type {string}
     * @memberof LastReadMessageResponseDto
     */
    senderId: string;
    /**
     * 
     * @type {string}
     * @memberof LastReadMessageResponseDto
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof LastReadMessageResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof LastReadMessageResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof LastReadMessageResponseDto
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface MessageReadPusherDto
 */
export interface MessageReadPusherDto {
    /**
     * 
     * @type {string}
     * @memberof MessageReadPusherDto
     */
    chatId: string;
    /**
     * 
     * @type {LastReadMessageResponseDto}
     * @memberof MessageReadPusherDto
     */
    lastReadMessage: LastReadMessageResponseDto;
}
/**
 * 
 * @export
 * @interface OpenDisputeDto
 */
export interface OpenDisputeDto {
    /**
     * Описание проблемы или причины открытия спора
     * @type {string}
     * @memberof OpenDisputeDto
     */
    description: string;
}
/**
 * 
 * @export
 * @interface PaginatedDealsResponseDto
 */
export interface PaginatedDealsResponseDto {
    /**
     * Array of deals with relations
     * @type {Array<DealWithRelationsDto>}
     * @memberof PaginatedDealsResponseDto
     */
    data: Array<DealWithRelationsDto>;
    /**
     * 
     * @type {Cursor}
     * @memberof PaginatedDealsResponseDto
     */
    cursor: Cursor;
}
/**
 * 
 * @export
 * @interface PaginatedExecutionRequestsResponseDto
 */
export interface PaginatedExecutionRequestsResponseDto {
    /**
     * Array of execution requests with relations
     * @type {Array<GetExecutionRequestResponseDto>}
     * @memberof PaginatedExecutionRequestsResponseDto
     */
    data: Array<GetExecutionRequestResponseDto>;
    /**
     * 
     * @type {Cursor}
     * @memberof PaginatedExecutionRequestsResponseDto
     */
    cursor: Cursor;
}
/**
 * 
 * @export
 * @interface Portfolio
 */
export interface Portfolio {
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    s3Key: string;
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    profileId: string;
    /**
     * 
     * @type {Profile}
     * @memberof Portfolio
     */
    profile: Profile;
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof Portfolio
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface PortfolioDeleteResponseDto
 */
export interface PortfolioDeleteResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PortfolioDeleteResponseDto
     */
    id: string;
}
/**
 * 
 * @export
 * @interface PortfolioRequestDto
 */
export interface PortfolioRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PortfolioRequestDto
     */
    filename?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioRequestDto
     */
    externalUrl?: string;
}
/**
 * 
 * @export
 * @interface PortfolioResponseDto
 */
export interface PortfolioResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PortfolioResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioResponseDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioResponseDto
     */
    s3Key: string;
}
/**
 * 
 * @export
 * @interface PortfolioUploadFileResponseDto
 */
export interface PortfolioUploadFileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PortfolioUploadFileResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUploadFileResponseDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUploadFileResponseDto
     */
    s3Key: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioUploadFileResponseDto
     */
    profileId: string;
}
/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    avatarUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    deepLink: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    backgroundImageId: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    surname: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    shortDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    fullDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    website: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Profile
     */
    verified: boolean;
    /**
     * 
     * @type {number}
     * @memberof Profile
     */
    priority: number;
    /**
     * 
     * @type {Array<Specialization>}
     * @memberof Profile
     */
    specializations?: Array<Specialization> | null;
    /**
     * 
     * @type {BackgroundImage}
     * @memberof Profile
     */
    backgroundImage?: BackgroundImage;
    /**
     * 
     * @type {Array<Portfolio>}
     * @memberof Profile
     */
    portfolios?: Array<Portfolio> | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface ProfileFromCompanionResponseDto
 */
export interface ProfileFromCompanionResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileFromCompanionResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromCompanionResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromCompanionResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromCompanionResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromCompanionResponseDto
     */
    avatarUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromCompanionResponseDto
     */
    deepLink: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromCompanionResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromCompanionResponseDto
     */
    surname: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromCompanionResponseDto
     */
    website: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileFromCompanionResponseDto
     */
    verified: boolean;
    /**
     * 
     * @type {Array<PortfolioResponseDto>}
     * @memberof ProfileFromCompanionResponseDto
     */
    portfolios?: Array<PortfolioResponseDto> | null;
}
/**
 * 
 * @export
 * @interface ProfileFromFollowerResponseDto
 */
export interface ProfileFromFollowerResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileFromFollowerResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromFollowerResponseDto
     */
    avatarUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromFollowerResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromFollowerResponseDto
     */
    surname: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileFromFollowerResponseDto
     */
    verified: boolean;
}
/**
 * 
 * @export
 * @interface ProfileFromMeResponseDto
 */
export interface ProfileFromMeResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    avatarUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    deepLink: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    surname: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    shortDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    fullDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromMeResponseDto
     */
    website: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileFromMeResponseDto
     */
    verified: boolean;
    /**
     * 
     * @type {Array<SpecializationFromProfile>}
     * @memberof ProfileFromMeResponseDto
     */
    specializations: Array<SpecializationFromProfile>;
    /**
     * 
     * @type {BackgroundImageResponseDto}
     * @memberof ProfileFromMeResponseDto
     */
    backgroundImage: BackgroundImageResponseDto;
    /**
     * 
     * @type {Array<PortfolioResponseDto>}
     * @memberof ProfileFromMeResponseDto
     */
    portfolios?: Array<PortfolioResponseDto> | null;
}
/**
 * 
 * @export
 * @interface ProfileFromUserResponseDto
 */
export interface ProfileFromUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    avatarUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    deepLink: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    surname: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    shortDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    fullDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileFromUserResponseDto
     */
    website: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileFromUserResponseDto
     */
    verified: boolean;
    /**
     * 
     * @type {Array<SpecializationFromProfile>}
     * @memberof ProfileFromUserResponseDto
     */
    specializations: Array<SpecializationFromProfile>;
    /**
     * 
     * @type {BackgroundImageResponseDto}
     * @memberof ProfileFromUserResponseDto
     */
    backgroundImage: BackgroundImageResponseDto;
    /**
     * 
     * @type {Array<PortfolioResponseDto>}
     * @memberof ProfileFromUserResponseDto
     */
    portfolios?: Array<PortfolioResponseDto> | null;
}
/**
 * 
 * @export
 * @interface ProfileResponseDto
 */
export interface ProfileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    avatarUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    deepLink: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    surname: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    shortDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    fullDescription: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileResponseDto
     */
    website: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileResponseDto
     */
    verified: boolean;
    /**
     * 
     * @type {Array<SpecializationFromProfile>}
     * @memberof ProfileResponseDto
     */
    specializations: Array<SpecializationFromProfile>;
    /**
     * 
     * @type {BackgroundImageResponseDto}
     * @memberof ProfileResponseDto
     */
    backgroundImage: BackgroundImageResponseDto;
    /**
     * 
     * @type {Array<PortfolioResponseDto>}
     * @memberof ProfileResponseDto
     */
    portfolios?: Array<PortfolioResponseDto> | null;
}
/**
 * 
 * @export
 * @interface PusherAuthRequestDto
 */
export interface PusherAuthRequestDto {
    /**
     * 
     * @type {string}
     * @memberof PusherAuthRequestDto
     */
    socket_id: string;
    /**
     * 
     * @type {string}
     * @memberof PusherAuthRequestDto
     */
    channel_name: string;
}
/**
 * 
 * @export
 * @interface PusherAuthResponseDto
 */
export interface PusherAuthResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PusherAuthResponseDto
     */
    auth: string;
    /**
     * 
     * @type {string}
     * @memberof PusherAuthResponseDto
     */
    channel_data?: string;
    /**
     * 
     * @type {string}
     * @memberof PusherAuthResponseDto
     */
    shared_secret?: string;
}
/**
 * 
 * @export
 * @interface ResetPasswordRequestDto
 */
export interface ResetPasswordRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequestDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequestDto
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequestDto
     */
    newPassword: string;
}
/**
 * 
 * @export
 * @interface ResetPasswordVerifyRequestDto
 */
export interface ResetPasswordVerifyRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordVerifyRequestDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordVerifyRequestDto
     */
    code: string;
}
/**
 * 
 * @export
 * @interface ResetPasswordVerifyResponseDto
 */
export interface ResetPasswordVerifyResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordVerifyResponseDto
     */
    key: string;
}
/**
 * 
 * @export
 * @interface SendCodeForResetPasswordRequestDto
 */
export interface SendCodeForResetPasswordRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SendCodeForResetPasswordRequestDto
     */
    phone: string;
}
/**
 * 
 * @export
 * @interface SendMessageRequestDto
 */
export interface SendMessageRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SendMessageRequestDto
     */
    content: string;
}
/**
 * 
 * @export
 * @interface SendMessageResponseDto
 */
export interface SendMessageResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SendMessageResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SendMessageResponseDto
     */
    chatId: string;
    /**
     * 
     * @type {string}
     * @memberof SendMessageResponseDto
     */
    senderId: string;
    /**
     * 
     * @type {string}
     * @memberof SendMessageResponseDto
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof SendMessageResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof SendMessageResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof SendMessageResponseDto
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface SetActiveVideoRequestDto
 */
export interface SetActiveVideoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SetActiveVideoRequestDto
     */
    name: string;
}
/**
 * 
 * @export
 * @interface SignInAdminRequestDto
 */
export interface SignInAdminRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SignInAdminRequestDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SignInAdminRequestDto
     */
    password: string;
}
/**
 * 
 * @export
 * @interface SignInRequestDto
 */
export interface SignInRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SignInRequestDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof SignInRequestDto
     */
    password: string;
}
/**
 * 
 * @export
 * @interface SignUpRequestDto
 */
export interface SignUpRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SignUpRequestDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof SignUpRequestDto
     */
    nickname: string;
    /**
     * 
     * @type {string}
     * @memberof SignUpRequestDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof SignUpRequestDto
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface SignUpVerifyRequestDto
 */
export interface SignUpVerifyRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SignUpVerifyRequestDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof SignUpVerifyRequestDto
     */
    code: string;
}
/**
 * 
 * @export
 * @interface Specialization
 */
export interface Specialization {
    /**
     * 
     * @type {string}
     * @memberof Specialization
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Specialization
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof Specialization
     */
    priority: number;
    /**
     * 
     * @type {string}
     * @memberof Specialization
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof Specialization
     */
    smallBackgroundImageUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof Specialization
     */
    backgroundImageUrl: string | null;
    /**
     * 
     * @type {Array<CategorySpecialization>}
     * @memberof Specialization
     */
    categories?: Array<CategorySpecialization>;
}
/**
 * 
 * @export
 * @interface SpecializationFromAdResponseDto
 */
export interface SpecializationFromAdResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SpecializationFromAdResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SpecializationFromAdResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SpecializationFromAdResponseDto
     */
    slug: string;
}
/**
 * 
 * @export
 * @interface SpecializationFromProfile
 */
export interface SpecializationFromProfile {
    /**
     * 
     * @type {string}
     * @memberof SpecializationFromProfile
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SpecializationFromProfile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SpecializationFromProfile
     */
    slug: string;
}
/**
 * 
 * @export
 * @interface SpecializationResponseDto
 */
export interface SpecializationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SpecializationResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SpecializationResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SpecializationResponseDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof SpecializationResponseDto
     */
    smallBackgroundImageUrl: string | null;
    /**
     * 
     * @type {string}
     * @memberof SpecializationResponseDto
     */
    backgroundImageUrl: string | null;
}
/**
 * 
 * @export
 * @interface TokensResponseDto
 */
export interface TokensResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TokensResponseDto
     */
    accessToken: string;
}
/**
 * 
 * @export
 * @interface UpdateAdRequestDto
 */
export interface UpdateAdRequestDto {
    /**
     * New title of the ad.
     * @type {string}
     * @memberof UpdateAdRequestDto
     */
    title?: string;
    /**
     * New background image of the ad.
     * @type {string}
     * @memberof UpdateAdRequestDto
     */
    backgroundImageId?: string;
    /**
     * New start date of the ad.
     * @type {string}
     * @memberof UpdateAdRequestDto
     */
    startDate?: string | null;
    /**
     * New due date of the ad.
     * @type {string}
     * @memberof UpdateAdRequestDto
     */
    dueDate?: string | null;
    /**
     * New reward of the ad.
     * @type {number}
     * @memberof UpdateAdRequestDto
     */
    price?: number;
    /**
     * New description of the ad.
     * @type {string}
     * @memberof UpdateAdRequestDto
     */
    description?: string;
    /**
     * New specialization IDs for the ad (1-5 items)
     * @type {Array<string>}
     * @memberof UpdateAdRequestDto
     */
    specializationIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateAdResponseDto
 */
export interface UpdateAdResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateAdResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdResponseDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdResponseDto
     */
    startDate: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdResponseDto
     */
    dueDate: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAdResponseDto
     */
    price: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateAdResponseDto
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAdResponseDto
     */
    isArchived: boolean;
    /**
     * 
     * @type {Array<SpecializationFromAdResponseDto>}
     * @memberof UpdateAdResponseDto
     */
    specializations: Array<SpecializationFromAdResponseDto>;
    /**
     * 
     * @type {BackgroundImageResponseDto}
     * @memberof UpdateAdResponseDto
     */
    backgroundImage: BackgroundImageResponseDto;
    /**
     * 
     * @type {UserResponseDto}
     * @memberof UpdateAdResponseDto
     */
    owner: UserResponseDto;
}
/**
 * 
 * @export
 * @interface UpdateLastReadMessageRequestDto
 */
export interface UpdateLastReadMessageRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLastReadMessageRequestDto
     */
    messageId: string;
}
/**
 * 
 * @export
 * @interface UpdateNotificationRequestDto
 */
export interface UpdateNotificationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateNotificationRequestDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNotificationRequestDto
     */
    notificationTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNotificationRequestDto
     */
    notificationBody?: string;
}
/**
 * 
 * @export
 * @interface UpdateProfileRequestDto
 */
export interface UpdateProfileRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequestDto
     */
    nickname?: string;
    /**
     * URL of the profile\'s avatar
     * @type {string}
     * @memberof UpdateProfileRequestDto
     */
    avatarUrl?: string | null;
    /**
     * Deep link of the profile
     * @type {string}
     * @memberof UpdateProfileRequestDto
     */
    deepLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequestDto
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequestDto
     */
    shortDescription?: string | null;
    /**
     * Full profile\'s description
     * @type {string}
     * @memberof UpdateProfileRequestDto
     */
    fullDescription?: string | null;
    /**
     * Profile\'s website
     * @type {string}
     * @memberof UpdateProfileRequestDto
     */
    website?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProfileRequestDto
     */
    specializationIds?: Array<string> | null;
    /**
     * UUIDv4 of the profile\'s background image
     * @type {string}
     * @memberof UpdateProfileRequestDto
     */
    backgroundImageId?: string;
}
/**
 * 
 * @export
 * @interface UpdateProfileResponseDto
 */
export interface UpdateProfileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileResponseDto
     */
    nickname: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProfileResponseDto
     */
    isBlocked: boolean;
    /**
     * 
     * @type {ProfileResponseDto}
     * @memberof UpdateProfileResponseDto
     */
    profile: ProfileResponseDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileResponseDto
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileResponseDto
     */
    email: string | null;
}
/**
 * 
 * @export
 * @interface UpdateUserFieldsValidationErrorDto
 */
export interface UpdateUserFieldsValidationErrorDto {
    /**
     * 
     * @type {Array<FieldValidationErrorFromUpdateUserDto>}
     * @memberof UpdateUserFieldsValidationErrorDto
     */
    errors: Array<FieldValidationErrorFromUpdateUserDto>;
}
/**
 * 
 * @export
 * @interface UpdateUserNotificationsSettingsRequestDto
 */
export interface UpdateUserNotificationsSettingsRequestDto {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserNotificationsSettingsRequestDto
     */
    disabled?: boolean;
}
/**
 * 
 * @export
 * @interface UploadFileRequestDto
 */
export interface UploadFileRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UploadFileRequestDto
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof UploadFileRequestDto
     */
    uploadType: UploadFileRequestDtoUploadTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UploadFileRequestDtoUploadTypeEnum {
    Avatars = 'avatars',
    AppMedia = 'app-media',
    Portfolio = 'portfolio'
}

/**
 * 
 * @export
 * @interface UploadFileResponseDto
 */
export interface UploadFileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponseDto
     */
    signedUrl: string;
    /**
     * 
     * @type {string}
     * @memberof UploadFileResponseDto
     */
    fileKey: string;
}
/**
 * 
 * @export
 * @interface UploadMediaRequestDto
 */
export interface UploadMediaRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UploadMediaRequestDto
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof UploadMediaRequestDto
     */
    mediaKind: UploadMediaRequestDtoMediaKindEnum;
    /**
     * 
     * @type {string}
     * @memberof UploadMediaRequestDto
     */
    userId?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UploadMediaRequestDtoMediaKindEnum {
    MainPageFirstVideo = 'mainPageFirstVideo',
    MainPageSecondVideo = 'mainPageSecondVideo',
    MainPageFirstBanner = 'mainPageFirstBanner',
    MainPageSecondBanner = 'mainPageSecondBanner'
}

/**
 * 
 * @export
 * @interface UploadMediaResponseDto
 */
export interface UploadMediaResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UploadMediaResponseDto
     */
    fileKey: string;
    /**
     * 
     * @type {string}
     * @memberof UploadMediaResponseDto
     */
    signedUrl: string;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    nickname: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    isBlocked: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    profileId: string | null;
    /**
     * 
     * @type {Profile}
     * @memberof User
     */
    profile?: Profile;
    /**
     * 
     * @type {UserNotificationsSettings}
     * @memberof User
     */
    notificationsSettings?: UserNotificationsSettings;
    /**
     * 
     * @type {Array<Ad>}
     * @memberof User
     */
    ads?: Array<Ad>;
    /**
     * 
     * @type {Array<FavoriteUser>}
     * @memberof User
     */
    favUsers?: Array<FavoriteUser>;
    /**
     * 
     * @type {Array<UserFollow>}
     * @memberof User
     */
    followers?: Array<UserFollow>;
    /**
     * 
     * @type {Array<UserFollow>}
     * @memberof User
     */
    following?: Array<UserFollow>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lang?: UserLangEnum;
    /**
     * 
     * @type {Array<UserFcm>}
     * @memberof User
     */
    fcms?: Array<UserFcm>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    deletedAt: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UserLangEnum {
    Ru = 'ru'
}

/**
 * 
 * @export
 * @interface UserFcm
 */
export interface UserFcm {
    /**
     * 
     * @type {string}
     * @memberof UserFcm
     */
    deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof UserFcm
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof UserFcm
     */
    userId: string;
    /**
     * 
     * @type {User}
     * @memberof UserFcm
     */
    user?: User;
    /**
     * 
     * @type {string}
     * @memberof UserFcm
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserFcm
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserFcm
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface UserFcmTokenDto
 */
export interface UserFcmTokenDto {
    /**
     * 
     * @type {string}
     * @memberof UserFcmTokenDto
     */
    fcmToken: string;
    /**
     * 
     * @type {string}
     * @memberof UserFcmTokenDto
     */
    deviceId: string;
}
/**
 * 
 * @export
 * @interface UserFollow
 */
export interface UserFollow {
    /**
     * 
     * @type {string}
     * @memberof UserFollow
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserFollow
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof UserFollow
     */
    followerId: string;
    /**
     * 
     * @type {User}
     * @memberof UserFollow
     */
    user: User;
    /**
     * 
     * @type {User}
     * @memberof UserFollow
     */
    follower: User;
    /**
     * 
     * @type {string}
     * @memberof UserFollow
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserFollow
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserFollow
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface UserFromUsersResponseDto
 */
export interface UserFromUsersResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UserFromUsersResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserFromUsersResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserFromUsersResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserFromUsersResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserFromUsersResponseDto
     */
    nickname: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserFromUsersResponseDto
     */
    isBlocked: boolean;
    /**
     * 
     * @type {ProfileFromUserResponseDto}
     * @memberof UserFromUsersResponseDto
     */
    profile: ProfileFromUserResponseDto;
    /**
     * 
     * @type {string}
     * @memberof UserFromUsersResponseDto
     */
    chatId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserFromUsersResponseDto
     */
    banned?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserFromUsersResponseDto
     */
    bannedByMe?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserFromUsersResponseDto
     */
    followers: number;
    /**
     * 
     * @type {number}
     * @memberof UserFromUsersResponseDto
     */
    following: number;
}
/**
 * 
 * @export
 * @interface UserNotificationsSettings
 */
export interface UserNotificationsSettings {
    /**
     * 
     * @type {string}
     * @memberof UserNotificationsSettings
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationsSettings
     */
    disabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationsSettings
     */
    userId: string;
    /**
     * 
     * @type {User}
     * @memberof UserNotificationsSettings
     */
    user?: User;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationsSettings
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationsSettings
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationsSettings
     */
    deletedAt: string | null;
}
/**
 * 
 * @export
 * @interface UserResponseDto
 */
export interface UserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    deletedAt: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponseDto
     */
    nickname: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseDto
     */
    isBlocked: boolean;
    /**
     * 
     * @type {ProfileResponseDto}
     * @memberof UserResponseDto
     */
    profile: ProfileResponseDto;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerGetHello: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {'DEBIT' | 'CREDIT' | 'CANCELLED_DEBIT' | 'CANCELLED_CREDIT' | 'AUTHORISE'} mNTCOMMAND Этап обработки операции
         * @param {string} mNTID Идентификатор ТСП (номер счета магазина в Монете)
         * @param {string} mNTTRANSACTIONID Внешний идентификатор заказа (clientTransaction)
         * @param {string} mNTOPERATIONID Идентификатор операции в Монете
         * @param {string} mNTAMOUNT Сумма в рублях с двумя знаками после точки
         * @param {string} mNTCURRENCYCODE Код валюты операции (например, RUB)
         * @param {string} mNTSIGNATURE Подпись запроса
         * @param {string} [mNTSUBSCRIBERID] Идентификатор плательщика (если есть)
         * @param {string} [mNTTESTMODE] Признак тестового режима
         * @param {string} [mNTCORRACCOUNT] Корр. счет (приходит в уведомлениях Монеты)
         * @param {string} [cardnumber] 
         * @param {string} [eNTERPAGE] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monetaWebhookControllerHandleAssistantWebhook: async (mNTCOMMAND: 'DEBIT' | 'CREDIT' | 'CANCELLED_DEBIT' | 'CANCELLED_CREDIT' | 'AUTHORISE', mNTID: string, mNTTRANSACTIONID: string, mNTOPERATIONID: string, mNTAMOUNT: string, mNTCURRENCYCODE: string, mNTSIGNATURE: string, mNTSUBSCRIBERID?: string, mNTTESTMODE?: string, mNTCORRACCOUNT?: string, cardnumber?: string, eNTERPAGE?: string, version?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mNTCOMMAND' is not null or undefined
            assertParamExists('monetaWebhookControllerHandleAssistantWebhook', 'mNTCOMMAND', mNTCOMMAND)
            // verify required parameter 'mNTID' is not null or undefined
            assertParamExists('monetaWebhookControllerHandleAssistantWebhook', 'mNTID', mNTID)
            // verify required parameter 'mNTTRANSACTIONID' is not null or undefined
            assertParamExists('monetaWebhookControllerHandleAssistantWebhook', 'mNTTRANSACTIONID', mNTTRANSACTIONID)
            // verify required parameter 'mNTOPERATIONID' is not null or undefined
            assertParamExists('monetaWebhookControllerHandleAssistantWebhook', 'mNTOPERATIONID', mNTOPERATIONID)
            // verify required parameter 'mNTAMOUNT' is not null or undefined
            assertParamExists('monetaWebhookControllerHandleAssistantWebhook', 'mNTAMOUNT', mNTAMOUNT)
            // verify required parameter 'mNTCURRENCYCODE' is not null or undefined
            assertParamExists('monetaWebhookControllerHandleAssistantWebhook', 'mNTCURRENCYCODE', mNTCURRENCYCODE)
            // verify required parameter 'mNTSIGNATURE' is not null or undefined
            assertParamExists('monetaWebhookControllerHandleAssistantWebhook', 'mNTSIGNATURE', mNTSIGNATURE)
            const localVarPath = `/v1/moneta/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mNTCOMMAND !== undefined) {
                localVarQueryParameter['MNT_COMMAND'] = mNTCOMMAND;
            }

            if (mNTID !== undefined) {
                localVarQueryParameter['MNT_ID'] = mNTID;
            }

            if (mNTTRANSACTIONID !== undefined) {
                localVarQueryParameter['MNT_TRANSACTION_ID'] = mNTTRANSACTIONID;
            }

            if (mNTOPERATIONID !== undefined) {
                localVarQueryParameter['MNT_OPERATION_ID'] = mNTOPERATIONID;
            }

            if (mNTAMOUNT !== undefined) {
                localVarQueryParameter['MNT_AMOUNT'] = mNTAMOUNT;
            }

            if (mNTCURRENCYCODE !== undefined) {
                localVarQueryParameter['MNT_CURRENCY_CODE'] = mNTCURRENCYCODE;
            }

            if (mNTSUBSCRIBERID !== undefined) {
                localVarQueryParameter['MNT_SUBSCRIBER_ID'] = mNTSUBSCRIBERID;
            }

            if (mNTTESTMODE !== undefined) {
                localVarQueryParameter['MNT_TEST_MODE'] = mNTTESTMODE;
            }

            if (mNTCORRACCOUNT !== undefined) {
                localVarQueryParameter['MNT_CORRACCOUNT'] = mNTCORRACCOUNT;
            }

            if (mNTSIGNATURE !== undefined) {
                localVarQueryParameter['MNT_SIGNATURE'] = mNTSIGNATURE;
            }

            if (cardnumber !== undefined) {
                localVarQueryParameter['cardnumber'] = cardnumber;
            }

            if (eNTERPAGE !== undefined) {
                localVarQueryParameter['ENTER_PAGE'] = eNTERPAGE;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appControllerGetHello(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appControllerGetHello(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {'DEBIT' | 'CREDIT' | 'CANCELLED_DEBIT' | 'CANCELLED_CREDIT' | 'AUTHORISE'} mNTCOMMAND Этап обработки операции
         * @param {string} mNTID Идентификатор ТСП (номер счета магазина в Монете)
         * @param {string} mNTTRANSACTIONID Внешний идентификатор заказа (clientTransaction)
         * @param {string} mNTOPERATIONID Идентификатор операции в Монете
         * @param {string} mNTAMOUNT Сумма в рублях с двумя знаками после точки
         * @param {string} mNTCURRENCYCODE Код валюты операции (например, RUB)
         * @param {string} mNTSIGNATURE Подпись запроса
         * @param {string} [mNTSUBSCRIBERID] Идентификатор плательщика (если есть)
         * @param {string} [mNTTESTMODE] Признак тестового режима
         * @param {string} [mNTCORRACCOUNT] Корр. счет (приходит в уведомлениях Монеты)
         * @param {string} [cardnumber] 
         * @param {string} [eNTERPAGE] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monetaWebhookControllerHandleAssistantWebhook(mNTCOMMAND: 'DEBIT' | 'CREDIT' | 'CANCELLED_DEBIT' | 'CANCELLED_CREDIT' | 'AUTHORISE', mNTID: string, mNTTRANSACTIONID: string, mNTOPERATIONID: string, mNTAMOUNT: string, mNTCURRENCYCODE: string, mNTSIGNATURE: string, mNTSUBSCRIBERID?: string, mNTTESTMODE?: string, mNTCORRACCOUNT?: string, cardnumber?: string, eNTERPAGE?: string, version?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monetaWebhookControllerHandleAssistantWebhook(mNTCOMMAND, mNTID, mNTTRANSACTIONID, mNTOPERATIONID, mNTAMOUNT, mNTCURRENCYCODE, mNTSIGNATURE, mNTSUBSCRIBERID, mNTTESTMODE, mNTCORRACCOUNT, cardnumber, eNTERPAGE, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerGetHello(options?: any): AxiosPromise<string> {
            return localVarFp.appControllerGetHello(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {'DEBIT' | 'CREDIT' | 'CANCELLED_DEBIT' | 'CANCELLED_CREDIT' | 'AUTHORISE'} mNTCOMMAND Этап обработки операции
         * @param {string} mNTID Идентификатор ТСП (номер счета магазина в Монете)
         * @param {string} mNTTRANSACTIONID Внешний идентификатор заказа (clientTransaction)
         * @param {string} mNTOPERATIONID Идентификатор операции в Монете
         * @param {string} mNTAMOUNT Сумма в рублях с двумя знаками после точки
         * @param {string} mNTCURRENCYCODE Код валюты операции (например, RUB)
         * @param {string} mNTSIGNATURE Подпись запроса
         * @param {string} [mNTSUBSCRIBERID] Идентификатор плательщика (если есть)
         * @param {string} [mNTTESTMODE] Признак тестового режима
         * @param {string} [mNTCORRACCOUNT] Корр. счет (приходит в уведомлениях Монеты)
         * @param {string} [cardnumber] 
         * @param {string} [eNTERPAGE] 
         * @param {string} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monetaWebhookControllerHandleAssistantWebhook(mNTCOMMAND: 'DEBIT' | 'CREDIT' | 'CANCELLED_DEBIT' | 'CANCELLED_CREDIT' | 'AUTHORISE', mNTID: string, mNTTRANSACTIONID: string, mNTOPERATIONID: string, mNTAMOUNT: string, mNTCURRENCYCODE: string, mNTSIGNATURE: string, mNTSUBSCRIBERID?: string, mNTTESTMODE?: string, mNTCORRACCOUNT?: string, cardnumber?: string, eNTERPAGE?: string, version?: string, options?: any): AxiosPromise<string> {
            return localVarFp.monetaWebhookControllerHandleAssistantWebhook(mNTCOMMAND, mNTID, mNTTRANSACTIONID, mNTOPERATIONID, mNTAMOUNT, mNTCURRENCYCODE, mNTSIGNATURE, mNTSUBSCRIBERID, mNTTESTMODE, mNTCORRACCOUNT, cardnumber, eNTERPAGE, version, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public appControllerGetHello(options?: any) {
        return DefaultApiFp(this.configuration).appControllerGetHello(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {'DEBIT' | 'CREDIT' | 'CANCELLED_DEBIT' | 'CANCELLED_CREDIT' | 'AUTHORISE'} mNTCOMMAND Этап обработки операции
     * @param {string} mNTID Идентификатор ТСП (номер счета магазина в Монете)
     * @param {string} mNTTRANSACTIONID Внешний идентификатор заказа (clientTransaction)
     * @param {string} mNTOPERATIONID Идентификатор операции в Монете
     * @param {string} mNTAMOUNT Сумма в рублях с двумя знаками после точки
     * @param {string} mNTCURRENCYCODE Код валюты операции (например, RUB)
     * @param {string} mNTSIGNATURE Подпись запроса
     * @param {string} [mNTSUBSCRIBERID] Идентификатор плательщика (если есть)
     * @param {string} [mNTTESTMODE] Признак тестового режима
     * @param {string} [mNTCORRACCOUNT] Корр. счет (приходит в уведомлениях Монеты)
     * @param {string} [cardnumber] 
     * @param {string} [eNTERPAGE] 
     * @param {string} [version] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public monetaWebhookControllerHandleAssistantWebhook(mNTCOMMAND: 'DEBIT' | 'CREDIT' | 'CANCELLED_DEBIT' | 'CANCELLED_CREDIT' | 'AUTHORISE', mNTID: string, mNTTRANSACTIONID: string, mNTOPERATIONID: string, mNTAMOUNT: string, mNTCURRENCYCODE: string, mNTSIGNATURE: string, mNTSUBSCRIBERID?: string, mNTTESTMODE?: string, mNTCORRACCOUNT?: string, cardnumber?: string, eNTERPAGE?: string, version?: string, options?: any) {
        return DefaultApiFp(this.configuration).monetaWebhookControllerHandleAssistantWebhook(mNTCOMMAND, mNTID, mNTTRANSACTIONID, mNTOPERATIONID, mNTAMOUNT, mNTCURRENCYCODE, mNTSIGNATURE, mNTSUBSCRIBERID, mNTTESTMODE, mNTCORRACCOUNT, cardnumber, eNTERPAGE, version, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1AdminsApi - axios parameter creator
 * @export
 */
export const V1AdminsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin sign in
         * @param {SignInAdminRequestDto} signInAdminRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerSignIn: async (signInAdminRequestDto: SignInAdminRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'signInAdminRequestDto' is not null or undefined
            assertParamExists('adminControllerSignIn', 'signInAdminRequestDto', signInAdminRequestDto)
            const localVarPath = `/v1/admins/sign-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signInAdminRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1AdminsApi - functional programming interface
 * @export
 */
export const V1AdminsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1AdminsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin sign in
         * @param {SignInAdminRequestDto} signInAdminRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminControllerSignIn(signInAdminRequestDto: SignInAdminRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokensResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminControllerSignIn(signInAdminRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1AdminsApi - factory interface
 * @export
 */
export const V1AdminsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1AdminsApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin sign in
         * @param {SignInAdminRequestDto} signInAdminRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerSignIn(signInAdminRequestDto: SignInAdminRequestDto, options?: any): AxiosPromise<TokensResponseDto> {
            return localVarFp.adminControllerSignIn(signInAdminRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1AdminsApi - object-oriented interface
 * @export
 * @class V1AdminsApi
 * @extends {BaseAPI}
 */
export class V1AdminsApi extends BaseAPI {
    /**
     * 
     * @summary Admin sign in
     * @param {SignInAdminRequestDto} signInAdminRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsApi
     */
    public adminControllerSignIn(signInAdminRequestDto: SignInAdminRequestDto, options?: any) {
        return V1AdminsApiFp(this.configuration).adminControllerSignIn(signInAdminRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1AdminsAppMediaApi - axios parameter creator
 * @export
 */
export const V1AdminsAppMediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Set an S3 link to the new active first banner
         * @summary Set an S3 link to the new active first banner
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppMediaControllerSetMainPageFirstBanner: async (setActiveVideoRequestDto: SetActiveVideoRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'setActiveVideoRequestDto' is not null or undefined
            assertParamExists('adminAppMediaControllerSetMainPageFirstBanner', 'setActiveVideoRequestDto', setActiveVideoRequestDto)
            const localVarPath = `/v1/admins/app/media/main-page-first-banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setActiveVideoRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set an S3 link to the new active first video
         * @summary Set an S3 link to the new active first video
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppMediaControllerSetMainPageFirstVideo: async (setActiveVideoRequestDto: SetActiveVideoRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'setActiveVideoRequestDto' is not null or undefined
            assertParamExists('adminAppMediaControllerSetMainPageFirstVideo', 'setActiveVideoRequestDto', setActiveVideoRequestDto)
            const localVarPath = `/v1/admins/app/media/main-page-first-video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setActiveVideoRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set an S3 link to the new active second banner
         * @summary Set an S3 link to the new active second banner
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppMediaControllerSetMainPageSecondBanner: async (setActiveVideoRequestDto: SetActiveVideoRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'setActiveVideoRequestDto' is not null or undefined
            assertParamExists('adminAppMediaControllerSetMainPageSecondBanner', 'setActiveVideoRequestDto', setActiveVideoRequestDto)
            const localVarPath = `/v1/admins/app/media/main-page-second-banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setActiveVideoRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set an S3 link to the new active second video
         * @summary Set an S3 link to the new active second video
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppMediaControllerSetMainPageSecondVideo: async (setActiveVideoRequestDto: SetActiveVideoRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'setActiveVideoRequestDto' is not null or undefined
            assertParamExists('adminAppMediaControllerSetMainPageSecondVideo', 'setActiveVideoRequestDto', setActiveVideoRequestDto)
            const localVarPath = `/v1/admins/app/media/main-page-second-video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setActiveVideoRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1AdminsAppMediaApi - functional programming interface
 * @export
 */
export const V1AdminsAppMediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1AdminsAppMediaApiAxiosParamCreator(configuration)
    return {
        /**
         * Set an S3 link to the new active first banner
         * @summary Set an S3 link to the new active first banner
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAppMediaControllerSetMainPageFirstBanner(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAppMediaControllerSetMainPageFirstBanner(setActiveVideoRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set an S3 link to the new active first video
         * @summary Set an S3 link to the new active first video
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAppMediaControllerSetMainPageFirstVideo(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAppMediaControllerSetMainPageFirstVideo(setActiveVideoRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set an S3 link to the new active second banner
         * @summary Set an S3 link to the new active second banner
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAppMediaControllerSetMainPageSecondBanner(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAppMediaControllerSetMainPageSecondBanner(setActiveVideoRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Set an S3 link to the new active second video
         * @summary Set an S3 link to the new active second video
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAppMediaControllerSetMainPageSecondVideo(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAppMediaControllerSetMainPageSecondVideo(setActiveVideoRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1AdminsAppMediaApi - factory interface
 * @export
 */
export const V1AdminsAppMediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1AdminsAppMediaApiFp(configuration)
    return {
        /**
         * Set an S3 link to the new active first banner
         * @summary Set an S3 link to the new active first banner
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppMediaControllerSetMainPageFirstBanner(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any): AxiosPromise<AppMedia> {
            return localVarFp.adminAppMediaControllerSetMainPageFirstBanner(setActiveVideoRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Set an S3 link to the new active first video
         * @summary Set an S3 link to the new active first video
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppMediaControllerSetMainPageFirstVideo(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any): AxiosPromise<AppMedia> {
            return localVarFp.adminAppMediaControllerSetMainPageFirstVideo(setActiveVideoRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Set an S3 link to the new active second banner
         * @summary Set an S3 link to the new active second banner
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppMediaControllerSetMainPageSecondBanner(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any): AxiosPromise<AppMedia> {
            return localVarFp.adminAppMediaControllerSetMainPageSecondBanner(setActiveVideoRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Set an S3 link to the new active second video
         * @summary Set an S3 link to the new active second video
         * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAppMediaControllerSetMainPageSecondVideo(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any): AxiosPromise<AppMedia> {
            return localVarFp.adminAppMediaControllerSetMainPageSecondVideo(setActiveVideoRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1AdminsAppMediaApi - object-oriented interface
 * @export
 * @class V1AdminsAppMediaApi
 * @extends {BaseAPI}
 */
export class V1AdminsAppMediaApi extends BaseAPI {
    /**
     * Set an S3 link to the new active first banner
     * @summary Set an S3 link to the new active first banner
     * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsAppMediaApi
     */
    public adminAppMediaControllerSetMainPageFirstBanner(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any) {
        return V1AdminsAppMediaApiFp(this.configuration).adminAppMediaControllerSetMainPageFirstBanner(setActiveVideoRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set an S3 link to the new active first video
     * @summary Set an S3 link to the new active first video
     * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsAppMediaApi
     */
    public adminAppMediaControllerSetMainPageFirstVideo(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any) {
        return V1AdminsAppMediaApiFp(this.configuration).adminAppMediaControllerSetMainPageFirstVideo(setActiveVideoRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set an S3 link to the new active second banner
     * @summary Set an S3 link to the new active second banner
     * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsAppMediaApi
     */
    public adminAppMediaControllerSetMainPageSecondBanner(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any) {
        return V1AdminsAppMediaApiFp(this.configuration).adminAppMediaControllerSetMainPageSecondBanner(setActiveVideoRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set an S3 link to the new active second video
     * @summary Set an S3 link to the new active second video
     * @param {SetActiveVideoRequestDto} setActiveVideoRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsAppMediaApi
     */
    public adminAppMediaControllerSetMainPageSecondVideo(setActiveVideoRequestDto: SetActiveVideoRequestDto, options?: any) {
        return V1AdminsAppMediaApiFp(this.configuration).adminAppMediaControllerSetMainPageSecondVideo(setActiveVideoRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1AdminsAppMediaStorageApi - axios parameter creator
 * @export
 */
export const V1AdminsAppMediaStorageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a media file from S3 and app database
         * @summary Delete a media
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaStorageControllerDeleteMedia: async (key: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('appMediaStorageControllerDeleteMedia', 'key', key)
            const localVarPath = `/v1/admins/app/media/storage/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all S3 bucket content. Returns database entities, not the actual S3 objects
         * @summary List all S3 objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaStorageControllerGetAllMedia: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admins/app/media/storage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a link to upload any new media to the S3 bucket
         * @summary Get a link to upload any new media to the S3 bucket
         * @param {UploadMediaRequestDto} uploadMediaRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaStorageControllerGetSignedUrl: async (uploadMediaRequestDto: UploadMediaRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadMediaRequestDto' is not null or undefined
            assertParamExists('appMediaStorageControllerGetSignedUrl', 'uploadMediaRequestDto', uploadMediaRequestDto)
            const localVarPath = `/v1/admins/app/media/storage/signed-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadMediaRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1AdminsAppMediaStorageApi - functional programming interface
 * @export
 */
export const V1AdminsAppMediaStorageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1AdminsAppMediaStorageApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a media file from S3 and app database
         * @summary Delete a media
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appMediaStorageControllerDeleteMedia(key: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appMediaStorageControllerDeleteMedia(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List all S3 bucket content. Returns database entities, not the actual S3 objects
         * @summary List all S3 objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appMediaStorageControllerGetAllMedia(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AppMedia>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appMediaStorageControllerGetAllMedia(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a link to upload any new media to the S3 bucket
         * @summary Get a link to upload any new media to the S3 bucket
         * @param {UploadMediaRequestDto} uploadMediaRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appMediaStorageControllerGetSignedUrl(uploadMediaRequestDto: UploadMediaRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appMediaStorageControllerGetSignedUrl(uploadMediaRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1AdminsAppMediaStorageApi - factory interface
 * @export
 */
export const V1AdminsAppMediaStorageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1AdminsAppMediaStorageApiFp(configuration)
    return {
        /**
         * Delete a media file from S3 and app database
         * @summary Delete a media
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaStorageControllerDeleteMedia(key: string, options?: any): AxiosPromise<object> {
            return localVarFp.appMediaStorageControllerDeleteMedia(key, options).then((request) => request(axios, basePath));
        },
        /**
         * List all S3 bucket content. Returns database entities, not the actual S3 objects
         * @summary List all S3 objects
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaStorageControllerGetAllMedia(options?: any): AxiosPromise<Array<AppMedia>> {
            return localVarFp.appMediaStorageControllerGetAllMedia(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a link to upload any new media to the S3 bucket
         * @summary Get a link to upload any new media to the S3 bucket
         * @param {UploadMediaRequestDto} uploadMediaRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaStorageControllerGetSignedUrl(uploadMediaRequestDto: UploadMediaRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.appMediaStorageControllerGetSignedUrl(uploadMediaRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1AdminsAppMediaStorageApi - object-oriented interface
 * @export
 * @class V1AdminsAppMediaStorageApi
 * @extends {BaseAPI}
 */
export class V1AdminsAppMediaStorageApi extends BaseAPI {
    /**
     * Delete a media file from S3 and app database
     * @summary Delete a media
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsAppMediaStorageApi
     */
    public appMediaStorageControllerDeleteMedia(key: string, options?: any) {
        return V1AdminsAppMediaStorageApiFp(this.configuration).appMediaStorageControllerDeleteMedia(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all S3 bucket content. Returns database entities, not the actual S3 objects
     * @summary List all S3 objects
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsAppMediaStorageApi
     */
    public appMediaStorageControllerGetAllMedia(options?: any) {
        return V1AdminsAppMediaStorageApiFp(this.configuration).appMediaStorageControllerGetAllMedia(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a link to upload any new media to the S3 bucket
     * @summary Get a link to upload any new media to the S3 bucket
     * @param {UploadMediaRequestDto} uploadMediaRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsAppMediaStorageApi
     */
    public appMediaStorageControllerGetSignedUrl(uploadMediaRequestDto: UploadMediaRequestDto, options?: any) {
        return V1AdminsAppMediaStorageApiFp(this.configuration).appMediaStorageControllerGetSignedUrl(uploadMediaRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1AdminsComplaintsApi - axios parameter creator
 * @export
 */
export const V1AdminsComplaintsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get complaint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminComplaintControllerGetComplaint: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminComplaintControllerGetComplaint', 'id', id)
            const localVarPath = `/v1/admins/complaints/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all complaints
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseAdminComplaintControllerComplaint: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admins/complaints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields.join(COLLECTION_FORMATS.csv);
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1AdminsComplaintsApi - functional programming interface
 * @export
 */
export const V1AdminsComplaintsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1AdminsComplaintsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get complaint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminComplaintControllerGetComplaint(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComplaintResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminComplaintControllerGetComplaint(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all complaints
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseAdminComplaintControllerComplaint(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetComplaintsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseAdminComplaintControllerComplaint(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1AdminsComplaintsApi - factory interface
 * @export
 */
export const V1AdminsComplaintsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1AdminsComplaintsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get complaint
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminComplaintControllerGetComplaint(id: string, options?: any): AxiosPromise<ComplaintResponseDto> {
            return localVarFp.adminComplaintControllerGetComplaint(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all complaints
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseAdminComplaintControllerComplaint(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<AdminGetComplaintsResponseDto> {
            return localVarFp.getManyBaseAdminComplaintControllerComplaint(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1AdminsComplaintsApi - object-oriented interface
 * @export
 * @class V1AdminsComplaintsApi
 * @extends {BaseAPI}
 */
export class V1AdminsComplaintsApi extends BaseAPI {
    /**
     * 
     * @summary Get complaint
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsComplaintsApi
     */
    public adminComplaintControllerGetComplaint(id: string, options?: any) {
        return V1AdminsComplaintsApiFp(this.configuration).adminComplaintControllerGetComplaint(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all complaints
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsComplaintsApi
     */
    public getManyBaseAdminComplaintControllerComplaint(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any) {
        return V1AdminsComplaintsApiFp(this.configuration).getManyBaseAdminComplaintControllerComplaint(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1AdminsDisputesApi - axios parameter creator
 * @export
 */
export const V1AdminsDisputesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get dispute
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDisputeControllerGetDispute: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDisputeControllerGetDispute', 'id', id)
            const localVarPath = `/v1/admins/disputes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve dispute in favor of customer (cancel deal and return Moneta operations)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDisputeControllerResolveInFavorOfCustomer: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDisputeControllerResolveInFavorOfCustomer', 'id', id)
            const localVarPath = `/v1/admins/disputes/{id}/resolve-customer`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resolve dispute in favor of executor (mark deal as ReadyForPayment)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDisputeControllerResolveInFavorOfExecutor: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminDisputeControllerResolveInFavorOfExecutor', 'id', id)
            const localVarPath = `/v1/admins/disputes/{id}/resolve-executor`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all disputes
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseAdminDisputeControllerDispute: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admins/disputes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields.join(COLLECTION_FORMATS.csv);
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1AdminsDisputesApi - functional programming interface
 * @export
 */
export const V1AdminsDisputesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1AdminsDisputesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get dispute
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDisputeControllerGetDispute(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDisputeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDisputeControllerGetDispute(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resolve dispute in favor of customer (cancel deal and return Moneta operations)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDisputeControllerResolveInFavorOfCustomer(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResolveDisputeCustomerResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDisputeControllerResolveInFavorOfCustomer(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resolve dispute in favor of executor (mark deal as ReadyForPayment)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDisputeControllerResolveInFavorOfExecutor(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResolveDisputeExecutorResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDisputeControllerResolveInFavorOfExecutor(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all disputes
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseAdminDisputeControllerDispute(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetDisputesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseAdminDisputeControllerDispute(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1AdminsDisputesApi - factory interface
 * @export
 */
export const V1AdminsDisputesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1AdminsDisputesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get dispute
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDisputeControllerGetDispute(id: string, options?: any): AxiosPromise<AdminDisputeResponseDto> {
            return localVarFp.adminDisputeControllerGetDispute(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve dispute in favor of customer (cancel deal and return Moneta operations)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDisputeControllerResolveInFavorOfCustomer(id: string, options?: any): AxiosPromise<AdminResolveDisputeCustomerResponseDto> {
            return localVarFp.adminDisputeControllerResolveInFavorOfCustomer(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resolve dispute in favor of executor (mark deal as ReadyForPayment)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDisputeControllerResolveInFavorOfExecutor(id: string, options?: any): AxiosPromise<AdminResolveDisputeExecutorResponseDto> {
            return localVarFp.adminDisputeControllerResolveInFavorOfExecutor(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all disputes
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseAdminDisputeControllerDispute(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<AdminGetDisputesResponseDto> {
            return localVarFp.getManyBaseAdminDisputeControllerDispute(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1AdminsDisputesApi - object-oriented interface
 * @export
 * @class V1AdminsDisputesApi
 * @extends {BaseAPI}
 */
export class V1AdminsDisputesApi extends BaseAPI {
    /**
     * 
     * @summary Get dispute
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsDisputesApi
     */
    public adminDisputeControllerGetDispute(id: string, options?: any) {
        return V1AdminsDisputesApiFp(this.configuration).adminDisputeControllerGetDispute(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve dispute in favor of customer (cancel deal and return Moneta operations)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsDisputesApi
     */
    public adminDisputeControllerResolveInFavorOfCustomer(id: string, options?: any) {
        return V1AdminsDisputesApiFp(this.configuration).adminDisputeControllerResolveInFavorOfCustomer(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resolve dispute in favor of executor (mark deal as ReadyForPayment)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsDisputesApi
     */
    public adminDisputeControllerResolveInFavorOfExecutor(id: string, options?: any) {
        return V1AdminsDisputesApiFp(this.configuration).adminDisputeControllerResolveInFavorOfExecutor(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all disputes
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsDisputesApi
     */
    public getManyBaseAdminDisputeControllerDispute(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any) {
        return V1AdminsDisputesApiFp(this.configuration).getManyBaseAdminDisputeControllerDispute(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1AdminsPromotionNotificationsApi - axios parameter creator
 * @export
 */
export const V1AdminsPromotionNotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new notification(without sending it)
         * @summary Create notification
         * @param {CreateNotificationRequestDto} createNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerCreateNotification: async (createNotificationRequestDto: CreateNotificationRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNotificationRequestDto' is not null or undefined
            assertParamExists('adminNotificationsControllerCreateNotification', 'createNotificationRequestDto', createNotificationRequestDto)
            const localVarPath = `/v1/admins/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNotificationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete notification
         * @summary Delete notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerDeleteNotification: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminNotificationsControllerDeleteNotification', 'id', id)
            const localVarPath = `/v1/admins/notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update notification
         * @summary Update notification
         * @param {string} id 
         * @param {UpdateNotificationRequestDto} updateNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerEditNotification: async (id: string, updateNotificationRequestDto: UpdateNotificationRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminNotificationsControllerEditNotification', 'id', id)
            // verify required parameter 'updateNotificationRequestDto' is not null or undefined
            assertParamExists('adminNotificationsControllerEditNotification', 'updateNotificationRequestDto', updateNotificationRequestDto)
            const localVarPath = `/v1/admins/notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get notification
         * @summary Get notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerGetNotification: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminNotificationsControllerGetNotification', 'id', id)
            const localVarPath = `/v1/admins/notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get notification history
         * @summary Get notification history
         * @param {string} id 
         * @param {number} page Page number
         * @param {number} limit Per page limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerGetNotificationHistory: async (id: string, page: number, limit: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminNotificationsControllerGetNotificationHistory', 'id', id)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('adminNotificationsControllerGetNotificationHistory', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('adminNotificationsControllerGetNotificationHistory', 'limit', limit)
            const localVarPath = `/v1/admins/notifications/{id}/history`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send notification
         * @summary Send notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerSendNotification: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminNotificationsControllerSendNotification', 'id', id)
            const localVarPath = `/v1/admins/notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all created notifications
         * @summary Get all notifications
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseAdminNotificationsControllerAdminNotification: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admins/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields.join(COLLECTION_FORMATS.csv);
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1AdminsPromotionNotificationsApi - functional programming interface
 * @export
 */
export const V1AdminsPromotionNotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1AdminsPromotionNotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create new notification(without sending it)
         * @summary Create notification
         * @param {CreateNotificationRequestDto} createNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerCreateNotification(createNotificationRequestDto: CreateNotificationRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNotificationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerCreateNotification(createNotificationRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete notification
         * @summary Delete notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerDeleteNotification(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerDeleteNotification(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update notification
         * @summary Update notification
         * @param {string} id 
         * @param {UpdateNotificationRequestDto} updateNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerEditNotification(id: string, updateNotificationRequestDto: UpdateNotificationRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNotificationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerEditNotification(id, updateNotificationRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get notification
         * @summary Get notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerGetNotification(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNotificationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerGetNotification(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get notification history
         * @summary Get notification history
         * @param {string} id 
         * @param {number} page Page number
         * @param {number} limit Per page limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerGetNotificationHistory(id: string, page: number, limit: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNotificationHistoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerGetNotificationHistory(id, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send notification
         * @summary Send notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminNotificationsControllerSendNotification(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminNotificationsControllerSendNotification(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List all created notifications
         * @summary Get all notifications
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseAdminNotificationsControllerAdminNotification(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseAdminNotificationsControllerAdminNotification(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1AdminsPromotionNotificationsApi - factory interface
 * @export
 */
export const V1AdminsPromotionNotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1AdminsPromotionNotificationsApiFp(configuration)
    return {
        /**
         * Create new notification(without sending it)
         * @summary Create notification
         * @param {CreateNotificationRequestDto} createNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerCreateNotification(createNotificationRequestDto: CreateNotificationRequestDto, options?: any): AxiosPromise<AdminNotificationResponseDto> {
            return localVarFp.adminNotificationsControllerCreateNotification(createNotificationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete notification
         * @summary Delete notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerDeleteNotification(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationsControllerDeleteNotification(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update notification
         * @summary Update notification
         * @param {string} id 
         * @param {UpdateNotificationRequestDto} updateNotificationRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerEditNotification(id: string, updateNotificationRequestDto: UpdateNotificationRequestDto, options?: any): AxiosPromise<AdminNotificationResponseDto> {
            return localVarFp.adminNotificationsControllerEditNotification(id, updateNotificationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Get notification
         * @summary Get notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerGetNotification(id: string, options?: any): AxiosPromise<AdminNotificationResponseDto> {
            return localVarFp.adminNotificationsControllerGetNotification(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get notification history
         * @summary Get notification history
         * @param {string} id 
         * @param {number} page Page number
         * @param {number} limit Per page limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerGetNotificationHistory(id: string, page: number, limit: number, options?: any): AxiosPromise<AdminNotificationHistoryResponseDto> {
            return localVarFp.adminNotificationsControllerGetNotificationHistory(id, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Send notification
         * @summary Send notification
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotificationsControllerSendNotification(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminNotificationsControllerSendNotification(id, options).then((request) => request(axios, basePath));
        },
        /**
         * List all created notifications
         * @summary Get all notifications
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseAdminNotificationsControllerAdminNotification(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getManyBaseAdminNotificationsControllerAdminNotification(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1AdminsPromotionNotificationsApi - object-oriented interface
 * @export
 * @class V1AdminsPromotionNotificationsApi
 * @extends {BaseAPI}
 */
export class V1AdminsPromotionNotificationsApi extends BaseAPI {
    /**
     * Create new notification(without sending it)
     * @summary Create notification
     * @param {CreateNotificationRequestDto} createNotificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsPromotionNotificationsApi
     */
    public adminNotificationsControllerCreateNotification(createNotificationRequestDto: CreateNotificationRequestDto, options?: any) {
        return V1AdminsPromotionNotificationsApiFp(this.configuration).adminNotificationsControllerCreateNotification(createNotificationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete notification
     * @summary Delete notification
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsPromotionNotificationsApi
     */
    public adminNotificationsControllerDeleteNotification(id: string, options?: any) {
        return V1AdminsPromotionNotificationsApiFp(this.configuration).adminNotificationsControllerDeleteNotification(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update notification
     * @summary Update notification
     * @param {string} id 
     * @param {UpdateNotificationRequestDto} updateNotificationRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsPromotionNotificationsApi
     */
    public adminNotificationsControllerEditNotification(id: string, updateNotificationRequestDto: UpdateNotificationRequestDto, options?: any) {
        return V1AdminsPromotionNotificationsApiFp(this.configuration).adminNotificationsControllerEditNotification(id, updateNotificationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get notification
     * @summary Get notification
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsPromotionNotificationsApi
     */
    public adminNotificationsControllerGetNotification(id: string, options?: any) {
        return V1AdminsPromotionNotificationsApiFp(this.configuration).adminNotificationsControllerGetNotification(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get notification history
     * @summary Get notification history
     * @param {string} id 
     * @param {number} page Page number
     * @param {number} limit Per page limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsPromotionNotificationsApi
     */
    public adminNotificationsControllerGetNotificationHistory(id: string, page: number, limit: number, options?: any) {
        return V1AdminsPromotionNotificationsApiFp(this.configuration).adminNotificationsControllerGetNotificationHistory(id, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send notification
     * @summary Send notification
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsPromotionNotificationsApi
     */
    public adminNotificationsControllerSendNotification(id: string, options?: any) {
        return V1AdminsPromotionNotificationsApiFp(this.configuration).adminNotificationsControllerSendNotification(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all created notifications
     * @summary Get all notifications
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsPromotionNotificationsApi
     */
    public getManyBaseAdminNotificationsControllerAdminNotification(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any) {
        return V1AdminsPromotionNotificationsApiFp(this.configuration).getManyBaseAdminNotificationsControllerAdminNotification(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1AdminsUsersApi - axios parameter creator
 * @export
 */
export const V1AdminsUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Block user
         * @param {string} userid 
         * @param {BlockOrUnblockUserRequestDto} blockOrUnblockUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerBlockUser: async (userid: string, blockOrUnblockUserRequestDto: BlockOrUnblockUserRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userid' is not null or undefined
            assertParamExists('adminUsersControllerBlockUser', 'userid', userid)
            // verify required parameter 'blockOrUnblockUserRequestDto' is not null or undefined
            assertParamExists('adminUsersControllerBlockUser', 'blockOrUnblockUserRequestDto', blockOrUnblockUserRequestDto)
            const localVarPath = `/v1/admins/users/{userid}/block`
                .replace(`{${"userid"}}`, encodeURIComponent(String(userid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockOrUnblockUserRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerGetUser: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUsersControllerGetUser', 'id', id)
            const localVarPath = `/v1/admins/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unblock user
         * @param {string} userid 
         * @param {BlockOrUnblockUserRequestDto} blockOrUnblockUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerUnblockUser: async (userid: string, blockOrUnblockUserRequestDto: BlockOrUnblockUserRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userid' is not null or undefined
            assertParamExists('adminUsersControllerUnblockUser', 'userid', userid)
            // verify required parameter 'blockOrUnblockUserRequestDto' is not null or undefined
            assertParamExists('adminUsersControllerUnblockUser', 'blockOrUnblockUserRequestDto', blockOrUnblockUserRequestDto)
            const localVarPath = `/v1/admins/users/{userid}/unblock`
                .replace(`{${"userid"}}`, encodeURIComponent(String(userid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockOrUnblockUserRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user and his profile
         * @param {string} id 
         * @param {AdminUpdateUserProfileRequestDto} adminUpdateUserProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerUpdateProfile: async (id: string, adminUpdateUserProfileRequestDto: AdminUpdateUserProfileRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminUsersControllerUpdateProfile', 'id', id)
            // verify required parameter 'adminUpdateUserProfileRequestDto' is not null or undefined
            assertParamExists('adminUsersControllerUpdateProfile', 'adminUpdateUserProfileRequestDto', adminUpdateUserProfileRequestDto)
            const localVarPath = `/v1/admins/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateUserProfileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all users with profiles
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseAdminUsersControllerUser: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admins/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields.join(COLLECTION_FORMATS.csv);
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1AdminsUsersApi - functional programming interface
 * @export
 */
export const V1AdminsUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1AdminsUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Block user
         * @param {string} userid 
         * @param {BlockOrUnblockUserRequestDto} blockOrUnblockUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerBlockUser(userid: string, blockOrUnblockUserRequestDto: BlockOrUnblockUserRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerBlockUser(userid, blockOrUnblockUserRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerGetUser(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetUserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerGetUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unblock user
         * @param {string} userid 
         * @param {BlockOrUnblockUserRequestDto} blockOrUnblockUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerUnblockUser(userid: string, blockOrUnblockUserRequestDto: BlockOrUnblockUserRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerUnblockUser(userid, blockOrUnblockUserRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user and his profile
         * @param {string} id 
         * @param {AdminUpdateUserProfileRequestDto} adminUpdateUserProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUsersControllerUpdateProfile(id: string, adminUpdateUserProfileRequestDto: AdminUpdateUserProfileRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUpdateProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUsersControllerUpdateProfile(id, adminUpdateUserProfileRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all users with profiles
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseAdminUsersControllerUser(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetUsersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseAdminUsersControllerUser(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1AdminsUsersApi - factory interface
 * @export
 */
export const V1AdminsUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1AdminsUsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Block user
         * @param {string} userid 
         * @param {BlockOrUnblockUserRequestDto} blockOrUnblockUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerBlockUser(userid: string, blockOrUnblockUserRequestDto: BlockOrUnblockUserRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminUsersControllerBlockUser(userid, blockOrUnblockUserRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user data
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerGetUser(id: string, options?: any): AxiosPromise<AdminGetUserResponseDto> {
            return localVarFp.adminUsersControllerGetUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unblock user
         * @param {string} userid 
         * @param {BlockOrUnblockUserRequestDto} blockOrUnblockUserRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerUnblockUser(userid: string, blockOrUnblockUserRequestDto: BlockOrUnblockUserRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.adminUsersControllerUnblockUser(userid, blockOrUnblockUserRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user and his profile
         * @param {string} id 
         * @param {AdminUpdateUserProfileRequestDto} adminUpdateUserProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersControllerUpdateProfile(id: string, adminUpdateUserProfileRequestDto: AdminUpdateUserProfileRequestDto, options?: any): AxiosPromise<AdminUpdateProfileResponseDto> {
            return localVarFp.adminUsersControllerUpdateProfile(id, adminUpdateUserProfileRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all users with profiles
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseAdminUsersControllerUser(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<AdminGetUsersResponseDto> {
            return localVarFp.getManyBaseAdminUsersControllerUser(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1AdminsUsersApi - object-oriented interface
 * @export
 * @class V1AdminsUsersApi
 * @extends {BaseAPI}
 */
export class V1AdminsUsersApi extends BaseAPI {
    /**
     * 
     * @summary Block user
     * @param {string} userid 
     * @param {BlockOrUnblockUserRequestDto} blockOrUnblockUserRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsUsersApi
     */
    public adminUsersControllerBlockUser(userid: string, blockOrUnblockUserRequestDto: BlockOrUnblockUserRequestDto, options?: any) {
        return V1AdminsUsersApiFp(this.configuration).adminUsersControllerBlockUser(userid, blockOrUnblockUserRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user data
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsUsersApi
     */
    public adminUsersControllerGetUser(id: string, options?: any) {
        return V1AdminsUsersApiFp(this.configuration).adminUsersControllerGetUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unblock user
     * @param {string} userid 
     * @param {BlockOrUnblockUserRequestDto} blockOrUnblockUserRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsUsersApi
     */
    public adminUsersControllerUnblockUser(userid: string, blockOrUnblockUserRequestDto: BlockOrUnblockUserRequestDto, options?: any) {
        return V1AdminsUsersApiFp(this.configuration).adminUsersControllerUnblockUser(userid, blockOrUnblockUserRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user and his profile
     * @param {string} id 
     * @param {AdminUpdateUserProfileRequestDto} adminUpdateUserProfileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsUsersApi
     */
    public adminUsersControllerUpdateProfile(id: string, adminUpdateUserProfileRequestDto: AdminUpdateUserProfileRequestDto, options?: any) {
        return V1AdminsUsersApiFp(this.configuration).adminUsersControllerUpdateProfile(id, adminUpdateUserProfileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all users with profiles
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdminsUsersApi
     */
    public getManyBaseAdminUsersControllerUser(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any) {
        return V1AdminsUsersApiFp(this.configuration).getManyBaseAdminUsersControllerUser(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1AdsApi - axios parameter creator
 * @export
 */
export const V1AdsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Archive ad
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerArchiveAd: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adControllerArchiveAd', 'id', id)
            const localVarPath = `/v1/ads/{id}/archive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create ad
         * @param {CreateAdRequestDto} createAdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerCreateAd: async (createAdRequestDto: CreateAdRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAdRequestDto' is not null or undefined
            assertParamExists('adControllerCreateAd', 'createAdRequestDto', createAdRequestDto)
            const localVarPath = `/v1/ads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAdRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete ad
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerDeleteAd: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adControllerDeleteAd', 'id', id)
            const localVarPath = `/v1/ads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get ad by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerGetAdById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adControllerGetAdById', 'id', id)
            const localVarPath = `/v1/ads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all ads
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [title] Search by ad title (deprecated, use search instead)
         * @param {string} [search] Find by user name or surname or nickname
         * @param {string} [specializationId] Specialization id for filtering
         * @param {'dateAsc' | 'dateDesc' | 'priceAsc' | 'priceDesc' | 'verifiedProfileAsc' | 'verifiedProfileDesc' | 'ownerNameAsc' | 'ownerNameDesc'} [sortMode] Sorting mode. By default sorts by verified status(verified first), then by registration date(newest first).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerGetAds: async (afterCursor?: string, limit?: number, title?: string, search?: string, specializationId?: string, sortMode?: 'dateAsc' | 'dateDesc' | 'priceAsc' | 'priceDesc' | 'verifiedProfileAsc' | 'verifiedProfileDesc' | 'ownerNameAsc' | 'ownerNameDesc', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/ads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (specializationId !== undefined) {
                localVarQueryParameter['specializationId'] = specializationId;
            }

            if (sortMode !== undefined) {
                localVarQueryParameter['sortMode'] = sortMode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get deals by ad id
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerGetDealsByAdId: async (id: string, afterCursor?: string, limit?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adControllerGetDealsByAdId', 'id', id)
            const localVarPath = `/v1/ads/{id}/deals`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get execution requests by ad id
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerGetExecutionRequestsByAdId: async (id: string, afterCursor?: string, limit?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adControllerGetExecutionRequestsByAdId', 'id', id)
            const localVarPath = `/v1/ads/{id}/execution-requests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unarchive ad
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerUnarchiveAd: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adControllerUnarchiveAd', 'id', id)
            const localVarPath = `/v1/ads/{id}/unarchive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update ad
         * @param {string} id 
         * @param {UpdateAdRequestDto} updateAdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerUpdateAd: async (id: string, updateAdRequestDto: UpdateAdRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adControllerUpdateAd', 'id', id)
            // verify required parameter 'updateAdRequestDto' is not null or undefined
            assertParamExists('adControllerUpdateAd', 'updateAdRequestDto', updateAdRequestDto)
            const localVarPath = `/v1/ads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAdRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1AdsApi - functional programming interface
 * @export
 */
export const V1AdsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1AdsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Archive ad
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adControllerArchiveAd(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adControllerArchiveAd(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create ad
         * @param {CreateAdRequestDto} createAdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adControllerCreateAd(createAdRequestDto: CreateAdRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateAdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adControllerCreateAd(createAdRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete ad
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adControllerDeleteAd(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adControllerDeleteAd(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get ad by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adControllerGetAdById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adControllerGetAdById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all ads
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [title] Search by ad title (deprecated, use search instead)
         * @param {string} [search] Find by user name or surname or nickname
         * @param {string} [specializationId] Specialization id for filtering
         * @param {'dateAsc' | 'dateDesc' | 'priceAsc' | 'priceDesc' | 'verifiedProfileAsc' | 'verifiedProfileDesc' | 'ownerNameAsc' | 'ownerNameDesc'} [sortMode] Sorting mode. By default sorts by verified status(verified first), then by registration date(newest first).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adControllerGetAds(afterCursor?: string, limit?: number, title?: string, search?: string, specializationId?: string, sortMode?: 'dateAsc' | 'dateDesc' | 'priceAsc' | 'priceDesc' | 'verifiedProfileAsc' | 'verifiedProfileDesc' | 'ownerNameAsc' | 'ownerNameDesc', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPaginatedAdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adControllerGetAds(afterCursor, limit, title, search, specializationId, sortMode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get deals by ad id
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adControllerGetDealsByAdId(id: string, afterCursor?: string, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDealsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adControllerGetDealsByAdId(id, afterCursor, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get execution requests by ad id
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adControllerGetExecutionRequestsByAdId(id: string, afterCursor?: string, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedExecutionRequestsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adControllerGetExecutionRequestsByAdId(id, afterCursor, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unarchive ad
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adControllerUnarchiveAd(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adControllerUnarchiveAd(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update ad
         * @param {string} id 
         * @param {UpdateAdRequestDto} updateAdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adControllerUpdateAd(id: string, updateAdRequestDto: UpdateAdRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateAdResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adControllerUpdateAd(id, updateAdRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1AdsApi - factory interface
 * @export
 */
export const V1AdsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1AdsApiFp(configuration)
    return {
        /**
         * 
         * @summary Archive ad
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerArchiveAd(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adControllerArchiveAd(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create ad
         * @param {CreateAdRequestDto} createAdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerCreateAd(createAdRequestDto: CreateAdRequestDto, options?: any): AxiosPromise<CreateAdResponseDto> {
            return localVarFp.adControllerCreateAd(createAdRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete ad
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerDeleteAd(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adControllerDeleteAd(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get ad by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerGetAdById(id: string, options?: any): AxiosPromise<GetAdResponseDto> {
            return localVarFp.adControllerGetAdById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all ads
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [title] Search by ad title (deprecated, use search instead)
         * @param {string} [search] Find by user name or surname or nickname
         * @param {string} [specializationId] Specialization id for filtering
         * @param {'dateAsc' | 'dateDesc' | 'priceAsc' | 'priceDesc' | 'verifiedProfileAsc' | 'verifiedProfileDesc' | 'ownerNameAsc' | 'ownerNameDesc'} [sortMode] Sorting mode. By default sorts by verified status(verified first), then by registration date(newest first).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerGetAds(afterCursor?: string, limit?: number, title?: string, search?: string, specializationId?: string, sortMode?: 'dateAsc' | 'dateDesc' | 'priceAsc' | 'priceDesc' | 'verifiedProfileAsc' | 'verifiedProfileDesc' | 'ownerNameAsc' | 'ownerNameDesc', options?: any): AxiosPromise<GetPaginatedAdResponseDto> {
            return localVarFp.adControllerGetAds(afterCursor, limit, title, search, specializationId, sortMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get deals by ad id
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerGetDealsByAdId(id: string, afterCursor?: string, limit?: number, options?: any): AxiosPromise<PaginatedDealsResponseDto> {
            return localVarFp.adControllerGetDealsByAdId(id, afterCursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get execution requests by ad id
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerGetExecutionRequestsByAdId(id: string, afterCursor?: string, limit?: number, options?: any): AxiosPromise<PaginatedExecutionRequestsResponseDto> {
            return localVarFp.adControllerGetExecutionRequestsByAdId(id, afterCursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unarchive ad
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerUnarchiveAd(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adControllerUnarchiveAd(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update ad
         * @param {string} id 
         * @param {UpdateAdRequestDto} updateAdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adControllerUpdateAd(id: string, updateAdRequestDto: UpdateAdRequestDto, options?: any): AxiosPromise<UpdateAdResponseDto> {
            return localVarFp.adControllerUpdateAd(id, updateAdRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1AdsApi - object-oriented interface
 * @export
 * @class V1AdsApi
 * @extends {BaseAPI}
 */
export class V1AdsApi extends BaseAPI {
    /**
     * 
     * @summary Archive ad
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdsApi
     */
    public adControllerArchiveAd(id: string, options?: any) {
        return V1AdsApiFp(this.configuration).adControllerArchiveAd(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create ad
     * @param {CreateAdRequestDto} createAdRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdsApi
     */
    public adControllerCreateAd(createAdRequestDto: CreateAdRequestDto, options?: any) {
        return V1AdsApiFp(this.configuration).adControllerCreateAd(createAdRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete ad
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdsApi
     */
    public adControllerDeleteAd(id: string, options?: any) {
        return V1AdsApiFp(this.configuration).adControllerDeleteAd(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get ad by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdsApi
     */
    public adControllerGetAdById(id: string, options?: any) {
        return V1AdsApiFp(this.configuration).adControllerGetAdById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all ads
     * @param {string} [afterCursor] 
     * @param {number} [limit] 
     * @param {string} [title] Search by ad title (deprecated, use search instead)
     * @param {string} [search] Find by user name or surname or nickname
     * @param {string} [specializationId] Specialization id for filtering
     * @param {'dateAsc' | 'dateDesc' | 'priceAsc' | 'priceDesc' | 'verifiedProfileAsc' | 'verifiedProfileDesc' | 'ownerNameAsc' | 'ownerNameDesc'} [sortMode] Sorting mode. By default sorts by verified status(verified first), then by registration date(newest first).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdsApi
     */
    public adControllerGetAds(afterCursor?: string, limit?: number, title?: string, search?: string, specializationId?: string, sortMode?: 'dateAsc' | 'dateDesc' | 'priceAsc' | 'priceDesc' | 'verifiedProfileAsc' | 'verifiedProfileDesc' | 'ownerNameAsc' | 'ownerNameDesc', options?: any) {
        return V1AdsApiFp(this.configuration).adControllerGetAds(afterCursor, limit, title, search, specializationId, sortMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get deals by ad id
     * @param {string} id 
     * @param {string} [afterCursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdsApi
     */
    public adControllerGetDealsByAdId(id: string, afterCursor?: string, limit?: number, options?: any) {
        return V1AdsApiFp(this.configuration).adControllerGetDealsByAdId(id, afterCursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get execution requests by ad id
     * @param {string} id 
     * @param {string} [afterCursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdsApi
     */
    public adControllerGetExecutionRequestsByAdId(id: string, afterCursor?: string, limit?: number, options?: any) {
        return V1AdsApiFp(this.configuration).adControllerGetExecutionRequestsByAdId(id, afterCursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unarchive ad
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdsApi
     */
    public adControllerUnarchiveAd(id: string, options?: any) {
        return V1AdsApiFp(this.configuration).adControllerUnarchiveAd(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update ad
     * @param {string} id 
     * @param {UpdateAdRequestDto} updateAdRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AdsApi
     */
    public adControllerUpdateAd(id: string, updateAdRequestDto: UpdateAdRequestDto, options?: any) {
        return V1AdsApiFp(this.configuration).adControllerUpdateAd(id, updateAdRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1AppMediaApi - axios parameter creator
 * @export
 */
export const V1AppMediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get an S3 link to the current active first banner
         * @summary Get an S3 link to the current active first banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaControllerGetMainPageFirstBanner: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/app/media/main-page-first-banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an S3 link to the current active first video
         * @summary Get an S3 link to the current active first video
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaControllerGetMainPageFirstVideo: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/app/media/main-page-first-video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an S3 link to the current active second banner
         * @summary Get an S3 link to the current active second banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaControllerGetMainPageSecondBanner: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/app/media/main-page-second-banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an S3 link to the current active second video
         * @summary Get an S3 link to the current active second video
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaControllerGetMainPageSecondVideo: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/app/media/main-page-second-video`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1AppMediaApi - functional programming interface
 * @export
 */
export const V1AppMediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1AppMediaApiAxiosParamCreator(configuration)
    return {
        /**
         * Get an S3 link to the current active first banner
         * @summary Get an S3 link to the current active first banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appMediaControllerGetMainPageFirstBanner(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appMediaControllerGetMainPageFirstBanner(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get an S3 link to the current active first video
         * @summary Get an S3 link to the current active first video
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appMediaControllerGetMainPageFirstVideo(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appMediaControllerGetMainPageFirstVideo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get an S3 link to the current active second banner
         * @summary Get an S3 link to the current active second banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appMediaControllerGetMainPageSecondBanner(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appMediaControllerGetMainPageSecondBanner(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get an S3 link to the current active second video
         * @summary Get an S3 link to the current active second video
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appMediaControllerGetMainPageSecondVideo(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppMedia>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appMediaControllerGetMainPageSecondVideo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1AppMediaApi - factory interface
 * @export
 */
export const V1AppMediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1AppMediaApiFp(configuration)
    return {
        /**
         * Get an S3 link to the current active first banner
         * @summary Get an S3 link to the current active first banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaControllerGetMainPageFirstBanner(options?: any): AxiosPromise<AppMedia> {
            return localVarFp.appMediaControllerGetMainPageFirstBanner(options).then((request) => request(axios, basePath));
        },
        /**
         * Get an S3 link to the current active first video
         * @summary Get an S3 link to the current active first video
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaControllerGetMainPageFirstVideo(options?: any): AxiosPromise<AppMedia> {
            return localVarFp.appMediaControllerGetMainPageFirstVideo(options).then((request) => request(axios, basePath));
        },
        /**
         * Get an S3 link to the current active second banner
         * @summary Get an S3 link to the current active second banner
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaControllerGetMainPageSecondBanner(options?: any): AxiosPromise<AppMedia> {
            return localVarFp.appMediaControllerGetMainPageSecondBanner(options).then((request) => request(axios, basePath));
        },
        /**
         * Get an S3 link to the current active second video
         * @summary Get an S3 link to the current active second video
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appMediaControllerGetMainPageSecondVideo(options?: any): AxiosPromise<AppMedia> {
            return localVarFp.appMediaControllerGetMainPageSecondVideo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1AppMediaApi - object-oriented interface
 * @export
 * @class V1AppMediaApi
 * @extends {BaseAPI}
 */
export class V1AppMediaApi extends BaseAPI {
    /**
     * Get an S3 link to the current active first banner
     * @summary Get an S3 link to the current active first banner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AppMediaApi
     */
    public appMediaControllerGetMainPageFirstBanner(options?: any) {
        return V1AppMediaApiFp(this.configuration).appMediaControllerGetMainPageFirstBanner(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an S3 link to the current active first video
     * @summary Get an S3 link to the current active first video
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AppMediaApi
     */
    public appMediaControllerGetMainPageFirstVideo(options?: any) {
        return V1AppMediaApiFp(this.configuration).appMediaControllerGetMainPageFirstVideo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an S3 link to the current active second banner
     * @summary Get an S3 link to the current active second banner
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AppMediaApi
     */
    public appMediaControllerGetMainPageSecondBanner(options?: any) {
        return V1AppMediaApiFp(this.configuration).appMediaControllerGetMainPageSecondBanner(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get an S3 link to the current active second video
     * @summary Get an S3 link to the current active second video
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AppMediaApi
     */
    public appMediaControllerGetMainPageSecondVideo(options?: any) {
        return V1AppMediaApiFp(this.configuration).appMediaControllerGetMainPageSecondVideo(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1AuthApi - axios parameter creator
 * @export
 */
export const V1AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Reset the password by sms code
         * @param {ResetPasswordRequestDto} resetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResetPassword: async (resetPasswordRequestDto: ResetPasswordRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequestDto' is not null or undefined
            assertParamExists('authControllerResetPassword', 'resetPasswordRequestDto', resetPasswordRequestDto)
            const localVarPath = `/v1/auth/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a verification SMS code to reset password
         * @param {SendCodeForResetPasswordRequestDto} sendCodeForResetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendCodeForResetPassword: async (sendCodeForResetPasswordRequestDto: SendCodeForResetPasswordRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendCodeForResetPasswordRequestDto' is not null or undefined
            assertParamExists('authControllerSendCodeForResetPassword', 'sendCodeForResetPasswordRequestDto', sendCodeForResetPasswordRequestDto)
            const localVarPath = `/v1/auth/password/code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendCodeForResetPasswordRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User sign in
         * @param {SignInRequestDto} signInRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignIn: async (signInRequestDto: SignInRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'signInRequestDto' is not null or undefined
            assertParamExists('authControllerSignIn', 'signInRequestDto', signInRequestDto)
            const localVarPath = `/v1/auth/sign-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signInRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Registering new user
         * @param {SignUpRequestDto} signUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUp: async (signUpRequestDto: SignUpRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'signUpRequestDto' is not null or undefined
            assertParamExists('authControllerSignUp', 'signUpRequestDto', signUpRequestDto)
            const localVarPath = `/v1/auth/sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signUpRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirmation of registration of a new user
         * @param {SignUpVerifyRequestDto} signUpVerifyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUpVerify: async (signUpVerifyRequestDto: SignUpVerifyRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'signUpVerifyRequestDto' is not null or undefined
            assertParamExists('authControllerSignUpVerify', 'signUpVerifyRequestDto', signUpVerifyRequestDto)
            const localVarPath = `/v1/auth/sign-up/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signUpVerifyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify SMS code to reset password
         * @param {ResetPasswordVerifyRequestDto} resetPasswordVerifyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyForResetPassword: async (resetPasswordVerifyRequestDto: ResetPasswordVerifyRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordVerifyRequestDto' is not null or undefined
            assertParamExists('authControllerVerifyForResetPassword', 'resetPasswordVerifyRequestDto', resetPasswordVerifyRequestDto)
            const localVarPath = `/v1/auth/password/code/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordVerifyRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1AuthApi - functional programming interface
 * @export
 */
export const V1AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Reset the password by sms code
         * @param {ResetPasswordRequestDto} resetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerResetPassword(resetPasswordRequestDto: ResetPasswordRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerResetPassword(resetPasswordRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send a verification SMS code to reset password
         * @param {SendCodeForResetPasswordRequestDto} sendCodeForResetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSendCodeForResetPassword(sendCodeForResetPasswordRequestDto: SendCodeForResetPasswordRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSendCodeForResetPassword(sendCodeForResetPasswordRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary User sign in
         * @param {SignInRequestDto} signInRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSignIn(signInRequestDto: SignInRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSignIn(signInRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Registering new user
         * @param {SignUpRequestDto} signUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSignUp(signUpRequestDto: SignUpRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSignUp(signUpRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Confirmation of registration of a new user
         * @param {SignUpVerifyRequestDto} signUpVerifyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerSignUpVerify(signUpVerifyRequestDto: SignUpVerifyRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerSignUpVerify(signUpVerifyRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify SMS code to reset password
         * @param {ResetPasswordVerifyRequestDto} resetPasswordVerifyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerVerifyForResetPassword(resetPasswordVerifyRequestDto: ResetPasswordVerifyRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResetPasswordVerifyResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerVerifyForResetPassword(resetPasswordVerifyRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1AuthApi - factory interface
 * @export
 */
export const V1AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Reset the password by sms code
         * @param {ResetPasswordRequestDto} resetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResetPassword(resetPasswordRequestDto: ResetPasswordRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.authControllerResetPassword(resetPasswordRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a verification SMS code to reset password
         * @param {SendCodeForResetPasswordRequestDto} sendCodeForResetPasswordRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSendCodeForResetPassword(sendCodeForResetPasswordRequestDto: SendCodeForResetPasswordRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.authControllerSendCodeForResetPassword(sendCodeForResetPasswordRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User sign in
         * @param {SignInRequestDto} signInRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignIn(signInRequestDto: SignInRequestDto, options?: any): AxiosPromise<AuthResponseDto> {
            return localVarFp.authControllerSignIn(signInRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Registering new user
         * @param {SignUpRequestDto} signUpRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUp(signUpRequestDto: SignUpRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.authControllerSignUp(signUpRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirmation of registration of a new user
         * @param {SignUpVerifyRequestDto} signUpVerifyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUpVerify(signUpVerifyRequestDto: SignUpVerifyRequestDto, options?: any): AxiosPromise<AuthResponseDto> {
            return localVarFp.authControllerSignUpVerify(signUpVerifyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify SMS code to reset password
         * @param {ResetPasswordVerifyRequestDto} resetPasswordVerifyRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyForResetPassword(resetPasswordVerifyRequestDto: ResetPasswordVerifyRequestDto, options?: any): AxiosPromise<ResetPasswordVerifyResponseDto> {
            return localVarFp.authControllerVerifyForResetPassword(resetPasswordVerifyRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1AuthApi - object-oriented interface
 * @export
 * @class V1AuthApi
 * @extends {BaseAPI}
 */
export class V1AuthApi extends BaseAPI {
    /**
     * 
     * @summary Reset the password by sms code
     * @param {ResetPasswordRequestDto} resetPasswordRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AuthApi
     */
    public authControllerResetPassword(resetPasswordRequestDto: ResetPasswordRequestDto, options?: any) {
        return V1AuthApiFp(this.configuration).authControllerResetPassword(resetPasswordRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a verification SMS code to reset password
     * @param {SendCodeForResetPasswordRequestDto} sendCodeForResetPasswordRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AuthApi
     */
    public authControllerSendCodeForResetPassword(sendCodeForResetPasswordRequestDto: SendCodeForResetPasswordRequestDto, options?: any) {
        return V1AuthApiFp(this.configuration).authControllerSendCodeForResetPassword(sendCodeForResetPasswordRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User sign in
     * @param {SignInRequestDto} signInRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AuthApi
     */
    public authControllerSignIn(signInRequestDto: SignInRequestDto, options?: any) {
        return V1AuthApiFp(this.configuration).authControllerSignIn(signInRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Registering new user
     * @param {SignUpRequestDto} signUpRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AuthApi
     */
    public authControllerSignUp(signUpRequestDto: SignUpRequestDto, options?: any) {
        return V1AuthApiFp(this.configuration).authControllerSignUp(signUpRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirmation of registration of a new user
     * @param {SignUpVerifyRequestDto} signUpVerifyRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AuthApi
     */
    public authControllerSignUpVerify(signUpVerifyRequestDto: SignUpVerifyRequestDto, options?: any) {
        return V1AuthApiFp(this.configuration).authControllerSignUpVerify(signUpVerifyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify SMS code to reset password
     * @param {ResetPasswordVerifyRequestDto} resetPasswordVerifyRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1AuthApi
     */
    public authControllerVerifyForResetPassword(resetPasswordVerifyRequestDto: ResetPasswordVerifyRequestDto, options?: any) {
        return V1AuthApiFp(this.configuration).authControllerVerifyForResetPassword(resetPasswordVerifyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1BackgroundImagesApi - axios parameter creator
 * @export
 */
export const V1BackgroundImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all background images
         * @param {string} [afterCursor] 
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {Array<'profile' | 'ad' | 'category' | 'specialization'>} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backgroundImageControllerGetAll: async (afterCursor?: string, beforeCursor?: string, limit?: number, types?: Array<'profile' | 'ad' | 'category' | 'specialization'>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/background-images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (beforeCursor !== undefined) {
                localVarQueryParameter['beforeCursor'] = beforeCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (types) {
                localVarQueryParameter['types'] = types;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1BackgroundImagesApi - functional programming interface
 * @export
 */
export const V1BackgroundImagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1BackgroundImagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all background images
         * @param {string} [afterCursor] 
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {Array<'profile' | 'ad' | 'category' | 'specialization'>} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backgroundImageControllerGetAll(afterCursor?: string, beforeCursor?: string, limit?: number, types?: Array<'profile' | 'ad' | 'category' | 'specialization'>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBackgroundImagesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backgroundImageControllerGetAll(afterCursor, beforeCursor, limit, types, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1BackgroundImagesApi - factory interface
 * @export
 */
export const V1BackgroundImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1BackgroundImagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all background images
         * @param {string} [afterCursor] 
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {Array<'profile' | 'ad' | 'category' | 'specialization'>} [types] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backgroundImageControllerGetAll(afterCursor?: string, beforeCursor?: string, limit?: number, types?: Array<'profile' | 'ad' | 'category' | 'specialization'>, options?: any): AxiosPromise<GetBackgroundImagesResponseDto> {
            return localVarFp.backgroundImageControllerGetAll(afterCursor, beforeCursor, limit, types, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1BackgroundImagesApi - object-oriented interface
 * @export
 * @class V1BackgroundImagesApi
 * @extends {BaseAPI}
 */
export class V1BackgroundImagesApi extends BaseAPI {
    /**
     * 
     * @summary Get all background images
     * @param {string} [afterCursor] 
     * @param {string} [beforeCursor] 
     * @param {number} [limit] 
     * @param {Array<'profile' | 'ad' | 'category' | 'specialization'>} [types] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1BackgroundImagesApi
     */
    public backgroundImageControllerGetAll(afterCursor?: string, beforeCursor?: string, limit?: number, types?: Array<'profile' | 'ad' | 'category' | 'specialization'>, options?: any) {
        return V1BackgroundImagesApiFp(this.configuration).backgroundImageControllerGetAll(afterCursor, beforeCursor, limit, types, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1CategoriesApi - axios parameter creator
 * @export
 */
export const V1CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all categories
         * @param {string} [name] Find by name
         * @param {string} [slug] Find by slug. Used exact compare
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryControllerGetAllCategories: async (name?: string, slug?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get category by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryControllerGetCategoryById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('categoryControllerGetCategoryById', 'id', id)
            const localVarPath = `/v1/categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1CategoriesApi - functional programming interface
 * @export
 */
export const V1CategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1CategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all categories
         * @param {string} [name] Find by name
         * @param {string} [slug] Find by slug. Used exact compare
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async categoryControllerGetAllCategories(name?: string, slug?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCategoriesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.categoryControllerGetAllCategories(name, slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get category by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async categoryControllerGetCategoryById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCategoryResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.categoryControllerGetCategoryById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1CategoriesApi - factory interface
 * @export
 */
export const V1CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1CategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all categories
         * @param {string} [name] Find by name
         * @param {string} [slug] Find by slug. Used exact compare
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryControllerGetAllCategories(name?: string, slug?: string, options?: any): AxiosPromise<GetCategoriesResponseDto> {
            return localVarFp.categoryControllerGetAllCategories(name, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get category by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryControllerGetCategoryById(id: string, options?: any): AxiosPromise<GetCategoryResponseDto> {
            return localVarFp.categoryControllerGetCategoryById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1CategoriesApi - object-oriented interface
 * @export
 * @class V1CategoriesApi
 * @extends {BaseAPI}
 */
export class V1CategoriesApi extends BaseAPI {
    /**
     * 
     * @summary Get all categories
     * @param {string} [name] Find by name
     * @param {string} [slug] Find by slug. Used exact compare
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1CategoriesApi
     */
    public categoryControllerGetAllCategories(name?: string, slug?: string, options?: any) {
        return V1CategoriesApiFp(this.configuration).categoryControllerGetAllCategories(name, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get category by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1CategoriesApi
     */
    public categoryControllerGetCategoryById(id: string, options?: any) {
        return V1CategoriesApiFp(this.configuration).categoryControllerGetCategoryById(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1ChatsApi - axios parameter creator
 * @export
 */
export const V1ChatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create chat with one user
         * @param {CreateChatRequestDto} createChatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerCreateChat: async (createChatRequestDto: CreateChatRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createChatRequestDto' is not null or undefined
            assertParamExists('chatControllerCreateChat', 'createChatRequestDto', createChatRequestDto)
            const localVarPath = `/v1/chats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChatRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete chat by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerDeleteChat: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatControllerDeleteChat', 'id', id)
            const localVarPath = `/v1/chats/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get chat by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerGetChat: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatControllerGetChat', 'id', id)
            const localVarPath = `/v1/chats/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all chats of the current user
         * @param {string} [afterCursor] 
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {Array<string>} [ids] 
         * @param {string} [profileFullName] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerGetChats: async (afterCursor?: string, beforeCursor?: string, limit?: number, ids?: Array<string>, profileFullName?: string, search?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/chats/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (beforeCursor !== undefined) {
                localVarQueryParameter['beforeCursor'] = beforeCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (profileFullName !== undefined) {
                localVarQueryParameter['profileFullName'] = profileFullName;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the last read message in the chat
         * @param {string} id 
         * @param {UpdateLastReadMessageRequestDto} updateLastReadMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerSetLastReadMessage: async (id: string, updateLastReadMessageRequestDto: UpdateLastReadMessageRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('chatControllerSetLastReadMessage', 'id', id)
            // verify required parameter 'updateLastReadMessageRequestDto' is not null or undefined
            assertParamExists('chatControllerSetLastReadMessage', 'updateLastReadMessageRequestDto', updateLastReadMessageRequestDto)
            const localVarPath = `/v1/chats/{id}/last-read-message`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLastReadMessageRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1ChatsApi - functional programming interface
 * @export
 */
export const V1ChatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1ChatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create chat with one user
         * @param {CreateChatRequestDto} createChatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatControllerCreateChat(createChatRequestDto: CreateChatRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatControllerCreateChat(createChatRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete chat by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatControllerDeleteChat(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatControllerDeleteChat(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get chat by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatControllerGetChat(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatControllerGetChat(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all chats of the current user
         * @param {string} [afterCursor] 
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {Array<string>} [ids] 
         * @param {string} [profileFullName] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatControllerGetChats(afterCursor?: string, beforeCursor?: string, limit?: number, ids?: Array<string>, profileFullName?: string, search?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetChatsPaginatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatControllerGetChats(afterCursor, beforeCursor, limit, ids, profileFullName, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update the last read message in the chat
         * @param {string} id 
         * @param {UpdateLastReadMessageRequestDto} updateLastReadMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatControllerSetLastReadMessage(id: string, updateLastReadMessageRequestDto: UpdateLastReadMessageRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatControllerSetLastReadMessage(id, updateLastReadMessageRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1ChatsApi - factory interface
 * @export
 */
export const V1ChatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1ChatsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create chat with one user
         * @param {CreateChatRequestDto} createChatRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerCreateChat(createChatRequestDto: CreateChatRequestDto, options?: any): AxiosPromise<GetChatResponseDto> {
            return localVarFp.chatControllerCreateChat(createChatRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete chat by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerDeleteChat(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.chatControllerDeleteChat(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get chat by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerGetChat(id: string, options?: any): AxiosPromise<GetChatResponseDto> {
            return localVarFp.chatControllerGetChat(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all chats of the current user
         * @param {string} [afterCursor] 
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {Array<string>} [ids] 
         * @param {string} [profileFullName] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerGetChats(afterCursor?: string, beforeCursor?: string, limit?: number, ids?: Array<string>, profileFullName?: string, search?: string, options?: any): AxiosPromise<GetChatsPaginatedResponseDto> {
            return localVarFp.chatControllerGetChats(afterCursor, beforeCursor, limit, ids, profileFullName, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the last read message in the chat
         * @param {string} id 
         * @param {UpdateLastReadMessageRequestDto} updateLastReadMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatControllerSetLastReadMessage(id: string, updateLastReadMessageRequestDto: UpdateLastReadMessageRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.chatControllerSetLastReadMessage(id, updateLastReadMessageRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1ChatsApi - object-oriented interface
 * @export
 * @class V1ChatsApi
 * @extends {BaseAPI}
 */
export class V1ChatsApi extends BaseAPI {
    /**
     * 
     * @summary Create chat with one user
     * @param {CreateChatRequestDto} createChatRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ChatsApi
     */
    public chatControllerCreateChat(createChatRequestDto: CreateChatRequestDto, options?: any) {
        return V1ChatsApiFp(this.configuration).chatControllerCreateChat(createChatRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete chat by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ChatsApi
     */
    public chatControllerDeleteChat(id: string, options?: any) {
        return V1ChatsApiFp(this.configuration).chatControllerDeleteChat(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get chat by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ChatsApi
     */
    public chatControllerGetChat(id: string, options?: any) {
        return V1ChatsApiFp(this.configuration).chatControllerGetChat(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all chats of the current user
     * @param {string} [afterCursor] 
     * @param {string} [beforeCursor] 
     * @param {number} [limit] 
     * @param {Array<string>} [ids] 
     * @param {string} [profileFullName] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ChatsApi
     */
    public chatControllerGetChats(afterCursor?: string, beforeCursor?: string, limit?: number, ids?: Array<string>, profileFullName?: string, search?: string, options?: any) {
        return V1ChatsApiFp(this.configuration).chatControllerGetChats(afterCursor, beforeCursor, limit, ids, profileFullName, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the last read message in the chat
     * @param {string} id 
     * @param {UpdateLastReadMessageRequestDto} updateLastReadMessageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ChatsApi
     */
    public chatControllerSetLastReadMessage(id: string, updateLastReadMessageRequestDto: UpdateLastReadMessageRequestDto, options?: any) {
        return V1ChatsApiFp(this.configuration).chatControllerSetLastReadMessage(id, updateLastReadMessageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1ChatsMessagesApi - axios parameter creator
 * @export
 */
export const V1ChatsMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all messages from chat
         * @param {string} chatId 
         * @param {string} [afterCursor] 
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageChatControllerGetMessages: async (chatId: string, afterCursor?: string, beforeCursor?: string, limit?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('messageChatControllerGetMessages', 'chatId', chatId)
            const localVarPath = `/v1/chats/{chatId}/messages`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (beforeCursor !== undefined) {
                localVarQueryParameter['beforeCursor'] = beforeCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send message to chat
         * @param {string} chatId 
         * @param {SendMessageRequestDto} sendMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageChatControllerSendMessage: async (chatId: string, sendMessageRequestDto: SendMessageRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('messageChatControllerSendMessage', 'chatId', chatId)
            // verify required parameter 'sendMessageRequestDto' is not null or undefined
            assertParamExists('messageChatControllerSendMessage', 'sendMessageRequestDto', sendMessageRequestDto)
            const localVarPath = `/v1/chats/{chatId}/messages`
                .replace(`{${"chatId"}}`, encodeURIComponent(String(chatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendMessageRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1ChatsMessagesApi - functional programming interface
 * @export
 */
export const V1ChatsMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1ChatsMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all messages from chat
         * @param {string} chatId 
         * @param {string} [afterCursor] 
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageChatControllerGetMessages(chatId: string, afterCursor?: string, beforeCursor?: string, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMessagesPaginatedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageChatControllerGetMessages(chatId, afterCursor, beforeCursor, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send message to chat
         * @param {string} chatId 
         * @param {SendMessageRequestDto} sendMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageChatControllerSendMessage(chatId: string, sendMessageRequestDto: SendMessageRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendMessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageChatControllerSendMessage(chatId, sendMessageRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1ChatsMessagesApi - factory interface
 * @export
 */
export const V1ChatsMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1ChatsMessagesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all messages from chat
         * @param {string} chatId 
         * @param {string} [afterCursor] 
         * @param {string} [beforeCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageChatControllerGetMessages(chatId: string, afterCursor?: string, beforeCursor?: string, limit?: number, options?: any): AxiosPromise<GetMessagesPaginatedResponseDto> {
            return localVarFp.messageChatControllerGetMessages(chatId, afterCursor, beforeCursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send message to chat
         * @param {string} chatId 
         * @param {SendMessageRequestDto} sendMessageRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageChatControllerSendMessage(chatId: string, sendMessageRequestDto: SendMessageRequestDto, options?: any): AxiosPromise<SendMessageResponseDto> {
            return localVarFp.messageChatControllerSendMessage(chatId, sendMessageRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1ChatsMessagesApi - object-oriented interface
 * @export
 * @class V1ChatsMessagesApi
 * @extends {BaseAPI}
 */
export class V1ChatsMessagesApi extends BaseAPI {
    /**
     * 
     * @summary Get all messages from chat
     * @param {string} chatId 
     * @param {string} [afterCursor] 
     * @param {string} [beforeCursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ChatsMessagesApi
     */
    public messageChatControllerGetMessages(chatId: string, afterCursor?: string, beforeCursor?: string, limit?: number, options?: any) {
        return V1ChatsMessagesApiFp(this.configuration).messageChatControllerGetMessages(chatId, afterCursor, beforeCursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send message to chat
     * @param {string} chatId 
     * @param {SendMessageRequestDto} sendMessageRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ChatsMessagesApi
     */
    public messageChatControllerSendMessage(chatId: string, sendMessageRequestDto: SendMessageRequestDto, options?: any) {
        return V1ChatsMessagesApiFp(this.configuration).messageChatControllerSendMessage(chatId, sendMessageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1ComplaintsApi - axios parameter creator
 * @export
 */
export const V1ComplaintsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create complaint
         * @param {CreateComplaintRequestDto} createComplaintRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complaintControllerCreateComplaint: async (createComplaintRequestDto: CreateComplaintRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createComplaintRequestDto' is not null or undefined
            assertParamExists('complaintControllerCreateComplaint', 'createComplaintRequestDto', createComplaintRequestDto)
            const localVarPath = `/v1/complaints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createComplaintRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1ComplaintsApi - functional programming interface
 * @export
 */
export const V1ComplaintsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1ComplaintsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create complaint
         * @param {CreateComplaintRequestDto} createComplaintRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complaintControllerCreateComplaint(createComplaintRequestDto: CreateComplaintRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateComplaintResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complaintControllerCreateComplaint(createComplaintRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1ComplaintsApi - factory interface
 * @export
 */
export const V1ComplaintsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1ComplaintsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create complaint
         * @param {CreateComplaintRequestDto} createComplaintRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complaintControllerCreateComplaint(createComplaintRequestDto: CreateComplaintRequestDto, options?: any): AxiosPromise<CreateComplaintResponseDto> {
            return localVarFp.complaintControllerCreateComplaint(createComplaintRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1ComplaintsApi - object-oriented interface
 * @export
 * @class V1ComplaintsApi
 * @extends {BaseAPI}
 */
export class V1ComplaintsApi extends BaseAPI {
    /**
     * 
     * @summary Create complaint
     * @param {CreateComplaintRequestDto} createComplaintRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ComplaintsApi
     */
    public complaintControllerCreateComplaint(createComplaintRequestDto: CreateComplaintRequestDto, options?: any) {
        return V1ComplaintsApiFp(this.configuration).complaintControllerCreateComplaint(createComplaintRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1DealsApi - axios parameter creator
 * @export
 */
export const V1DealsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerAcceptDealById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dealControllerAcceptDealById', 'id', id)
            const localVarPath = `/v1/deals/{id}/accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel deal by id (Admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerCancelDealById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dealControllerCancelDealById', 'id', id)
            const localVarPath = `/v1/deals/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerGetDealById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dealControllerGetDealById', 'id', id)
            const localVarPath = `/v1/deals/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reward for deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerGetRewardById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dealControllerGetRewardById', 'id', id)
            const localVarPath = `/v1/deals/{id}/get-reward`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Init payout for deal (Moneta stub)
         * @param {string} id 
         * @param {InitPayoutRequestDto} initPayoutRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerInitPayoutStub: async (id: string, initPayoutRequestDto: InitPayoutRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dealControllerInitPayoutStub', 'id', id)
            // verify required parameter 'initPayoutRequestDto' is not null or undefined
            assertParamExists('dealControllerInitPayoutStub', 'initPayoutRequestDto', initPayoutRequestDto)
            const localVarPath = `/v1/deals/{id}/init-payout`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initPayoutRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Open dispute for deal by id
         * @param {string} id 
         * @param {OpenDisputeDto} openDisputeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerOpenDispute: async (id: string, openDisputeDto: OpenDisputeDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dealControllerOpenDispute', 'id', id)
            // verify required parameter 'openDisputeDto' is not null or undefined
            assertParamExists('dealControllerOpenDispute', 'openDisputeDto', openDisputeDto)
            const localVarPath = `/v1/deals/{id}/dispute`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(openDisputeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Rework deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerReworkDealById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dealControllerReworkDealById', 'id', id)
            const localVarPath = `/v1/deals/{id}/rework`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit for review deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerSubmitForReview: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('dealControllerSubmitForReview', 'id', id)
            const localVarPath = `/v1/deals/{id}/submit-for-review`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1DealsApi - functional programming interface
 * @export
 */
export const V1DealsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1DealsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dealControllerAcceptDealById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDealByIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dealControllerAcceptDealById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cancel deal by id (Admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dealControllerCancelDealById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDealByIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dealControllerCancelDealById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dealControllerGetDealById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDealByIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dealControllerGetDealById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get reward for deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dealControllerGetRewardById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDealByIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dealControllerGetRewardById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Init payout for deal (Moneta stub)
         * @param {string} id 
         * @param {InitPayoutRequestDto} initPayoutRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dealControllerInitPayoutStub(id: string, initPayoutRequestDto: InitPayoutRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dealControllerInitPayoutStub(id, initPayoutRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Open dispute for deal by id
         * @param {string} id 
         * @param {OpenDisputeDto} openDisputeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dealControllerOpenDispute(id: string, openDisputeDto: OpenDisputeDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dealControllerOpenDispute(id, openDisputeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Rework deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dealControllerReworkDealById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDealByIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dealControllerReworkDealById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Submit for review deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dealControllerSubmitForReview(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDealByIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dealControllerSubmitForReview(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1DealsApi - factory interface
 * @export
 */
export const V1DealsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1DealsApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerAcceptDealById(id: string, options?: any): AxiosPromise<GetDealByIdDto> {
            return localVarFp.dealControllerAcceptDealById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel deal by id (Admin only)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerCancelDealById(id: string, options?: any): AxiosPromise<GetDealByIdDto> {
            return localVarFp.dealControllerCancelDealById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerGetDealById(id: string, options?: any): AxiosPromise<GetDealByIdDto> {
            return localVarFp.dealControllerGetDealById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get reward for deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerGetRewardById(id: string, options?: any): AxiosPromise<GetDealByIdDto> {
            return localVarFp.dealControllerGetRewardById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Init payout for deal (Moneta stub)
         * @param {string} id 
         * @param {InitPayoutRequestDto} initPayoutRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerInitPayoutStub(id: string, initPayoutRequestDto: InitPayoutRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.dealControllerInitPayoutStub(id, initPayoutRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Open dispute for deal by id
         * @param {string} id 
         * @param {OpenDisputeDto} openDisputeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerOpenDispute(id: string, openDisputeDto: OpenDisputeDto, options?: any): AxiosPromise<void> {
            return localVarFp.dealControllerOpenDispute(id, openDisputeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Rework deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerReworkDealById(id: string, options?: any): AxiosPromise<GetDealByIdDto> {
            return localVarFp.dealControllerReworkDealById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit for review deal by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dealControllerSubmitForReview(id: string, options?: any): AxiosPromise<GetDealByIdDto> {
            return localVarFp.dealControllerSubmitForReview(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1DealsApi - object-oriented interface
 * @export
 * @class V1DealsApi
 * @extends {BaseAPI}
 */
export class V1DealsApi extends BaseAPI {
    /**
     * 
     * @summary Accept deal by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1DealsApi
     */
    public dealControllerAcceptDealById(id: string, options?: any) {
        return V1DealsApiFp(this.configuration).dealControllerAcceptDealById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel deal by id (Admin only)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1DealsApi
     */
    public dealControllerCancelDealById(id: string, options?: any) {
        return V1DealsApiFp(this.configuration).dealControllerCancelDealById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get deal by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1DealsApi
     */
    public dealControllerGetDealById(id: string, options?: any) {
        return V1DealsApiFp(this.configuration).dealControllerGetDealById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get reward for deal by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1DealsApi
     */
    public dealControllerGetRewardById(id: string, options?: any) {
        return V1DealsApiFp(this.configuration).dealControllerGetRewardById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Init payout for deal (Moneta stub)
     * @param {string} id 
     * @param {InitPayoutRequestDto} initPayoutRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1DealsApi
     */
    public dealControllerInitPayoutStub(id: string, initPayoutRequestDto: InitPayoutRequestDto, options?: any) {
        return V1DealsApiFp(this.configuration).dealControllerInitPayoutStub(id, initPayoutRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Open dispute for deal by id
     * @param {string} id 
     * @param {OpenDisputeDto} openDisputeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1DealsApi
     */
    public dealControllerOpenDispute(id: string, openDisputeDto: OpenDisputeDto, options?: any) {
        return V1DealsApiFp(this.configuration).dealControllerOpenDispute(id, openDisputeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Rework deal by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1DealsApi
     */
    public dealControllerReworkDealById(id: string, options?: any) {
        return V1DealsApiFp(this.configuration).dealControllerReworkDealById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit for review deal by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1DealsApi
     */
    public dealControllerSubmitForReview(id: string, options?: any) {
        return V1DealsApiFp(this.configuration).dealControllerSubmitForReview(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1ExecutionRequestApi - axios parameter creator
 * @export
 */
export const V1ExecutionRequestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept and pay for an execution request (Moneta stub)
         * @param {string} id Execution request ID
         * @param {AcceptAndPayRequestDto} acceptAndPayRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executionRequestControllerAcceptAndPayStub: async (id: string, acceptAndPayRequestDto: AcceptAndPayRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('executionRequestControllerAcceptAndPayStub', 'id', id)
            // verify required parameter 'acceptAndPayRequestDto' is not null or undefined
            assertParamExists('executionRequestControllerAcceptAndPayStub', 'acceptAndPayRequestDto', acceptAndPayRequestDto)
            const localVarPath = `/v1/execution-request/{id}/accept-and-pay`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptAndPayRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept an execution request (LEGACY)
         * @param {string} id Execution request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executionRequestControllerAcceptRequest: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('executionRequestControllerAcceptRequest', 'id', id)
            const localVarPath = `/v1/execution-request/{id}/accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates an execution request for an ad. Only the ad owner cannot create requests for their own ads.
         * @summary Create a new execution request
         * @param {CreateExecutionRequestDto} createExecutionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executionRequestControllerCreateRequest: async (createExecutionRequestDto: CreateExecutionRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createExecutionRequestDto' is not null or undefined
            assertParamExists('executionRequestControllerCreateRequest', 'createExecutionRequestDto', createExecutionRequestDto)
            const localVarPath = `/v1/execution-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createExecutionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get execution request by id (only for participants)
         * @param {string} id Execution request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executionRequestControllerGetExecutionRequestById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('executionRequestControllerGetExecutionRequestById', 'id', id)
            const localVarPath = `/v1/execution-request/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject an execution request (by ad owner) or cancel request (by executor)
         * @param {string} id Execution request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executionRequestControllerRejectRequest: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('executionRequestControllerRejectRequest', 'id', id)
            const localVarPath = `/v1/execution-request/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1ExecutionRequestApi - functional programming interface
 * @export
 */
export const V1ExecutionRequestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1ExecutionRequestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept and pay for an execution request (Moneta stub)
         * @param {string} id Execution request ID
         * @param {AcceptAndPayRequestDto} acceptAndPayRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executionRequestControllerAcceptAndPayStub(id: string, acceptAndPayRequestDto: AcceptAndPayRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executionRequestControllerAcceptAndPayStub(id, acceptAndPayRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Accept an execution request (LEGACY)
         * @param {string} id Execution request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executionRequestControllerAcceptRequest(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExecutionRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executionRequestControllerAcceptRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates an execution request for an ad. Only the ad owner cannot create requests for their own ads.
         * @summary Create a new execution request
         * @param {CreateExecutionRequestDto} createExecutionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executionRequestControllerCreateRequest(createExecutionRequestDto: CreateExecutionRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExecutionRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executionRequestControllerCreateRequest(createExecutionRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get execution request by id (only for participants)
         * @param {string} id Execution request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executionRequestControllerGetExecutionRequestById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExecutionRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executionRequestControllerGetExecutionRequestById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject an execution request (by ad owner) or cancel request (by executor)
         * @param {string} id Execution request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executionRequestControllerRejectRequest(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExecutionRequestResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executionRequestControllerRejectRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1ExecutionRequestApi - factory interface
 * @export
 */
export const V1ExecutionRequestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1ExecutionRequestApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept and pay for an execution request (Moneta stub)
         * @param {string} id Execution request ID
         * @param {AcceptAndPayRequestDto} acceptAndPayRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executionRequestControllerAcceptAndPayStub(id: string, acceptAndPayRequestDto: AcceptAndPayRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.executionRequestControllerAcceptAndPayStub(id, acceptAndPayRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept an execution request (LEGACY)
         * @param {string} id Execution request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executionRequestControllerAcceptRequest(id: string, options?: any): AxiosPromise<ExecutionRequestResponseDto> {
            return localVarFp.executionRequestControllerAcceptRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates an execution request for an ad. Only the ad owner cannot create requests for their own ads.
         * @summary Create a new execution request
         * @param {CreateExecutionRequestDto} createExecutionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executionRequestControllerCreateRequest(createExecutionRequestDto: CreateExecutionRequestDto, options?: any): AxiosPromise<GetExecutionRequestResponseDto> {
            return localVarFp.executionRequestControllerCreateRequest(createExecutionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get execution request by id (only for participants)
         * @param {string} id Execution request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executionRequestControllerGetExecutionRequestById(id: string, options?: any): AxiosPromise<GetExecutionRequestResponseDto> {
            return localVarFp.executionRequestControllerGetExecutionRequestById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject an execution request (by ad owner) or cancel request (by executor)
         * @param {string} id Execution request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executionRequestControllerRejectRequest(id: string, options?: any): AxiosPromise<GetExecutionRequestResponseDto> {
            return localVarFp.executionRequestControllerRejectRequest(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1ExecutionRequestApi - object-oriented interface
 * @export
 * @class V1ExecutionRequestApi
 * @extends {BaseAPI}
 */
export class V1ExecutionRequestApi extends BaseAPI {
    /**
     * 
     * @summary Accept and pay for an execution request (Moneta stub)
     * @param {string} id Execution request ID
     * @param {AcceptAndPayRequestDto} acceptAndPayRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ExecutionRequestApi
     */
    public executionRequestControllerAcceptAndPayStub(id: string, acceptAndPayRequestDto: AcceptAndPayRequestDto, options?: any) {
        return V1ExecutionRequestApiFp(this.configuration).executionRequestControllerAcceptAndPayStub(id, acceptAndPayRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept an execution request (LEGACY)
     * @param {string} id Execution request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ExecutionRequestApi
     */
    public executionRequestControllerAcceptRequest(id: string, options?: any) {
        return V1ExecutionRequestApiFp(this.configuration).executionRequestControllerAcceptRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates an execution request for an ad. Only the ad owner cannot create requests for their own ads.
     * @summary Create a new execution request
     * @param {CreateExecutionRequestDto} createExecutionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ExecutionRequestApi
     */
    public executionRequestControllerCreateRequest(createExecutionRequestDto: CreateExecutionRequestDto, options?: any) {
        return V1ExecutionRequestApiFp(this.configuration).executionRequestControllerCreateRequest(createExecutionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get execution request by id (only for participants)
     * @param {string} id Execution request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ExecutionRequestApi
     */
    public executionRequestControllerGetExecutionRequestById(id: string, options?: any) {
        return V1ExecutionRequestApiFp(this.configuration).executionRequestControllerGetExecutionRequestById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject an execution request (by ad owner) or cancel request (by executor)
     * @param {string} id Execution request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1ExecutionRequestApi
     */
    public executionRequestControllerRejectRequest(id: string, options?: any) {
        return V1ExecutionRequestApiFp(this.configuration).executionRequestControllerRejectRequest(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1MonetaApi - axios parameter creator
 * @export
 */
export const V1MonetaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get payment operations by dealId
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monetaStatusControllerGetByDealId: async (dealId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dealId' is not null or undefined
            assertParamExists('monetaStatusControllerGetByDealId', 'dealId', dealId)
            const localVarPath = `/v1/moneta/operations/by-deal/{dealId}`
                .replace(`{${"dealId"}}`, encodeURIComponent(String(dealId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get payment operation by externalId
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monetaStatusControllerGetByExternalId: async (externalId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('monetaStatusControllerGetByExternalId', 'externalId', externalId)
            const localVarPath = `/v1/moneta/operations/by-external/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1MonetaApi - functional programming interface
 * @export
 */
export const V1MonetaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1MonetaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get payment operations by dealId
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monetaStatusControllerGetByDealId(dealId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monetaStatusControllerGetByDealId(dealId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get payment operation by externalId
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async monetaStatusControllerGetByExternalId(externalId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.monetaStatusControllerGetByExternalId(externalId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1MonetaApi - factory interface
 * @export
 */
export const V1MonetaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1MonetaApiFp(configuration)
    return {
        /**
         * 
         * @summary Get payment operations by dealId
         * @param {string} dealId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monetaStatusControllerGetByDealId(dealId: string, options?: any): AxiosPromise<void> {
            return localVarFp.monetaStatusControllerGetByDealId(dealId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get payment operation by externalId
         * @param {string} externalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monetaStatusControllerGetByExternalId(externalId: string, options?: any): AxiosPromise<void> {
            return localVarFp.monetaStatusControllerGetByExternalId(externalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1MonetaApi - object-oriented interface
 * @export
 * @class V1MonetaApi
 * @extends {BaseAPI}
 */
export class V1MonetaApi extends BaseAPI {
    /**
     * 
     * @summary Get payment operations by dealId
     * @param {string} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1MonetaApi
     */
    public monetaStatusControllerGetByDealId(dealId: string, options?: any) {
        return V1MonetaApiFp(this.configuration).monetaStatusControllerGetByDealId(dealId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get payment operation by externalId
     * @param {string} externalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1MonetaApi
     */
    public monetaStatusControllerGetByExternalId(externalId: string, options?: any) {
        return V1MonetaApiFp(this.configuration).monetaStatusControllerGetByExternalId(externalId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1PortfoliosApi - axios parameter creator
 * @export
 */
export const V1PortfoliosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a portfolio from S3 and app database
         * @summary Delete a portfolio
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioControllerDeletePortfolio: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('portfolioControllerDeletePortfolio', 'id', id)
            const localVarPath = `/v1/portfolios/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a link to upload portfolio to the S3 bucket
         * @summary Get a link to upload new portfolio to the S3 bucket
         * @param {PortfolioRequestDto} portfolioRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioControllerGetSignedUrl: async (portfolioRequestDto: PortfolioRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioRequestDto' is not null or undefined
            assertParamExists('portfolioControllerGetSignedUrl', 'portfolioRequestDto', portfolioRequestDto)
            const localVarPath = `/v1/portfolios/signed-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolioRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload file to the S3 bucket
         * @summary Upload file to the S3 bucket
         * @param {string} [externalUrl] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioControllerUploadFile: async (externalUrl?: string, file?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/portfolios/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (externalUrl !== undefined) { 
                localVarFormParams.append('externalUrl', externalUrl as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1PortfoliosApi - functional programming interface
 * @export
 */
export const V1PortfoliosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1PortfoliosApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a portfolio from S3 and app database
         * @summary Delete a portfolio
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioControllerDeletePortfolio(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioControllerDeletePortfolio(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a link to upload portfolio to the S3 bucket
         * @summary Get a link to upload new portfolio to the S3 bucket
         * @param {PortfolioRequestDto} portfolioRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioControllerGetSignedUrl(portfolioRequestDto: PortfolioRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioControllerGetSignedUrl(portfolioRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload file to the S3 bucket
         * @summary Upload file to the S3 bucket
         * @param {string} [externalUrl] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portfolioControllerUploadFile(externalUrl?: string, file?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portfolioControllerUploadFile(externalUrl, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1PortfoliosApi - factory interface
 * @export
 */
export const V1PortfoliosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1PortfoliosApiFp(configuration)
    return {
        /**
         * Delete a portfolio from S3 and app database
         * @summary Delete a portfolio
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioControllerDeletePortfolio(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.portfolioControllerDeletePortfolio(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a link to upload portfolio to the S3 bucket
         * @summary Get a link to upload new portfolio to the S3 bucket
         * @param {PortfolioRequestDto} portfolioRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioControllerGetSignedUrl(portfolioRequestDto: PortfolioRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.portfolioControllerGetSignedUrl(portfolioRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload file to the S3 bucket
         * @summary Upload file to the S3 bucket
         * @param {string} [externalUrl] 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portfolioControllerUploadFile(externalUrl?: string, file?: any, options?: any): AxiosPromise<object> {
            return localVarFp.portfolioControllerUploadFile(externalUrl, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1PortfoliosApi - object-oriented interface
 * @export
 * @class V1PortfoliosApi
 * @extends {BaseAPI}
 */
export class V1PortfoliosApi extends BaseAPI {
    /**
     * Delete a portfolio from S3 and app database
     * @summary Delete a portfolio
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1PortfoliosApi
     */
    public portfolioControllerDeletePortfolio(id: string, options?: any) {
        return V1PortfoliosApiFp(this.configuration).portfolioControllerDeletePortfolio(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a link to upload portfolio to the S3 bucket
     * @summary Get a link to upload new portfolio to the S3 bucket
     * @param {PortfolioRequestDto} portfolioRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1PortfoliosApi
     */
    public portfolioControllerGetSignedUrl(portfolioRequestDto: PortfolioRequestDto, options?: any) {
        return V1PortfoliosApiFp(this.configuration).portfolioControllerGetSignedUrl(portfolioRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload file to the S3 bucket
     * @summary Upload file to the S3 bucket
     * @param {string} [externalUrl] 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1PortfoliosApi
     */
    public portfolioControllerUploadFile(externalUrl?: string, file?: any, options?: any) {
        return V1PortfoliosApiFp(this.configuration).portfolioControllerUploadFile(externalUrl, file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1PusherApi - axios parameter creator
 * @export
 */
export const V1PusherApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auth for presence and private pusher channels
         * @param {PusherAuthRequestDto} pusherAuthRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pusherControllerAuthenticate: async (pusherAuthRequestDto: PusherAuthRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pusherAuthRequestDto' is not null or undefined
            assertParamExists('pusherControllerAuthenticate', 'pusherAuthRequestDto', pusherAuthRequestDto)
            const localVarPath = `/v1/pusher/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pusherAuthRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1PusherApi - functional programming interface
 * @export
 */
export const V1PusherApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1PusherApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Auth for presence and private pusher channels
         * @param {PusherAuthRequestDto} pusherAuthRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pusherControllerAuthenticate(pusherAuthRequestDto: PusherAuthRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PusherAuthResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pusherControllerAuthenticate(pusherAuthRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1PusherApi - factory interface
 * @export
 */
export const V1PusherApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1PusherApiFp(configuration)
    return {
        /**
         * 
         * @summary Auth for presence and private pusher channels
         * @param {PusherAuthRequestDto} pusherAuthRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pusherControllerAuthenticate(pusherAuthRequestDto: PusherAuthRequestDto, options?: any): AxiosPromise<PusherAuthResponseDto> {
            return localVarFp.pusherControllerAuthenticate(pusherAuthRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1PusherApi - object-oriented interface
 * @export
 * @class V1PusherApi
 * @extends {BaseAPI}
 */
export class V1PusherApi extends BaseAPI {
    /**
     * 
     * @summary Auth for presence and private pusher channels
     * @param {PusherAuthRequestDto} pusherAuthRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1PusherApi
     */
    public pusherControllerAuthenticate(pusherAuthRequestDto: PusherAuthRequestDto, options?: any) {
        return V1PusherApiFp(this.configuration).pusherControllerAuthenticate(pusherAuthRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1SpecializationsApi - axios parameter creator
 * @export
 */
export const V1SpecializationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all specializations
         * @param {string} [name] 
         * @param {string} [slug] Find by slug. Used exact compare
         * @param {Array<string>} [categoryIds] 
         * @param {Array<'priorityASC' | 'nameASC'>} [sort] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetAllSpecializations: async (name?: string, slug?: string, categoryIds?: Array<string>, sort?: Array<'priorityASC' | 'nameASC'>, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/specializations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }

            if (categoryIds) {
                localVarQueryParameter['categoryIds'] = categoryIds;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get specialization by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetSpecializationById: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('specializationControllerGetSpecializationById', 'id', id)
            const localVarPath = `/v1/specializations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1SpecializationsApi - functional programming interface
 * @export
 */
export const V1SpecializationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1SpecializationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all specializations
         * @param {string} [name] 
         * @param {string} [slug] Find by slug. Used exact compare
         * @param {Array<string>} [categoryIds] 
         * @param {Array<'priorityASC' | 'nameASC'>} [sort] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationControllerGetAllSpecializations(name?: string, slug?: string, categoryIds?: Array<string>, sort?: Array<'priorityASC' | 'nameASC'>, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpecializationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationControllerGetAllSpecializations(name, slug, categoryIds, sort, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get specialization by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationControllerGetSpecializationById(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpecializationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationControllerGetSpecializationById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1SpecializationsApi - factory interface
 * @export
 */
export const V1SpecializationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1SpecializationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all specializations
         * @param {string} [name] 
         * @param {string} [slug] Find by slug. Used exact compare
         * @param {Array<string>} [categoryIds] 
         * @param {Array<'priorityASC' | 'nameASC'>} [sort] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetAllSpecializations(name?: string, slug?: string, categoryIds?: Array<string>, sort?: Array<'priorityASC' | 'nameASC'>, limit?: number, options?: any): AxiosPromise<GetSpecializationsResponseDto> {
            return localVarFp.specializationControllerGetAllSpecializations(name, slug, categoryIds, sort, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get specialization by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationControllerGetSpecializationById(id: string, options?: any): AxiosPromise<GetSpecializationResponseDto> {
            return localVarFp.specializationControllerGetSpecializationById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1SpecializationsApi - object-oriented interface
 * @export
 * @class V1SpecializationsApi
 * @extends {BaseAPI}
 */
export class V1SpecializationsApi extends BaseAPI {
    /**
     * 
     * @summary Get all specializations
     * @param {string} [name] 
     * @param {string} [slug] Find by slug. Used exact compare
     * @param {Array<string>} [categoryIds] 
     * @param {Array<'priorityASC' | 'nameASC'>} [sort] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1SpecializationsApi
     */
    public specializationControllerGetAllSpecializations(name?: string, slug?: string, categoryIds?: Array<string>, sort?: Array<'priorityASC' | 'nameASC'>, limit?: number, options?: any) {
        return V1SpecializationsApiFp(this.configuration).specializationControllerGetAllSpecializations(name, slug, categoryIds, sort, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get specialization by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1SpecializationsApi
     */
    public specializationControllerGetSpecializationById(id: string, options?: any) {
        return V1SpecializationsApiFp(this.configuration).specializationControllerGetSpecializationById(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1UploadFilesApi - axios parameter creator
 * @export
 */
export const V1UploadFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create signed url
         * @param {UploadFileRequestDto} uploadFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesUploadControllerCreateSignedUrl: async (uploadFileRequestDto: UploadFileRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadFileRequestDto' is not null or undefined
            assertParamExists('filesUploadControllerCreateSignedUrl', 'uploadFileRequestDto', uploadFileRequestDto)
            const localVarPath = `/v1/files-upload/create-signed-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadFileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1UploadFilesApi - functional programming interface
 * @export
 */
export const V1UploadFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1UploadFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create signed url
         * @param {UploadFileRequestDto} uploadFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filesUploadControllerCreateSignedUrl(uploadFileRequestDto: UploadFileRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadFileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filesUploadControllerCreateSignedUrl(uploadFileRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1UploadFilesApi - factory interface
 * @export
 */
export const V1UploadFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1UploadFilesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create signed url
         * @param {UploadFileRequestDto} uploadFileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesUploadControllerCreateSignedUrl(uploadFileRequestDto: UploadFileRequestDto, options?: any): AxiosPromise<UploadFileResponseDto> {
            return localVarFp.filesUploadControllerCreateSignedUrl(uploadFileRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1UploadFilesApi - object-oriented interface
 * @export
 * @class V1UploadFilesApi
 * @extends {BaseAPI}
 */
export class V1UploadFilesApi extends BaseAPI {
    /**
     * 
     * @summary Create signed url
     * @param {UploadFileRequestDto} uploadFileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UploadFilesApi
     */
    public filesUploadControllerCreateSignedUrl(uploadFileRequestDto: UploadFileRequestDto, options?: any) {
        return V1UploadFilesApiFp(this.configuration).filesUploadControllerCreateSignedUrl(uploadFileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1UserResponsesApi - axios parameter creator
 * @export
 */
export const V1UserResponsesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user deals with pagination
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userResponsesControllerGetUserDeals: async (id: string, afterCursor?: string, limit?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userResponsesControllerGetUserDeals', 'id', id)
            const localVarPath = `/v1/users/{id}/deals`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user execution requests (отклики) with pagination
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userResponsesControllerGetUserExecutionRequests: async (id: string, afterCursor?: string, limit?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userResponsesControllerGetUserExecutionRequests', 'id', id)
            const localVarPath = `/v1/users/{id}/execution-requests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1UserResponsesApi - functional programming interface
 * @export
 */
export const V1UserResponsesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1UserResponsesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user deals with pagination
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userResponsesControllerGetUserDeals(id: string, afterCursor?: string, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedDealsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userResponsesControllerGetUserDeals(id, afterCursor, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user execution requests (отклики) with pagination
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userResponsesControllerGetUserExecutionRequests(id: string, afterCursor?: string, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedExecutionRequestsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userResponsesControllerGetUserExecutionRequests(id, afterCursor, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1UserResponsesApi - factory interface
 * @export
 */
export const V1UserResponsesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1UserResponsesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user deals with pagination
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userResponsesControllerGetUserDeals(id: string, afterCursor?: string, limit?: number, options?: any): AxiosPromise<PaginatedDealsResponseDto> {
            return localVarFp.userResponsesControllerGetUserDeals(id, afterCursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user execution requests (отклики) with pagination
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userResponsesControllerGetUserExecutionRequests(id: string, afterCursor?: string, limit?: number, options?: any): AxiosPromise<PaginatedExecutionRequestsResponseDto> {
            return localVarFp.userResponsesControllerGetUserExecutionRequests(id, afterCursor, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1UserResponsesApi - object-oriented interface
 * @export
 * @class V1UserResponsesApi
 * @extends {BaseAPI}
 */
export class V1UserResponsesApi extends BaseAPI {
    /**
     * 
     * @summary Get user deals with pagination
     * @param {string} id 
     * @param {string} [afterCursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UserResponsesApi
     */
    public userResponsesControllerGetUserDeals(id: string, afterCursor?: string, limit?: number, options?: any) {
        return V1UserResponsesApiFp(this.configuration).userResponsesControllerGetUserDeals(id, afterCursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user execution requests (отклики) with pagination
     * @param {string} id 
     * @param {string} [afterCursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UserResponsesApi
     */
    public userResponsesControllerGetUserExecutionRequests(id: string, afterCursor?: string, limit?: number, options?: any) {
        return V1UserResponsesApiFp(this.configuration).userResponsesControllerGetUserExecutionRequests(id, afterCursor, limit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * V1UsersApi - axios parameter creator
 * @export
 */
export const V1UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create profile of the current user
         * @param {CreateProfileRequestDto} createProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileUserControllerCreateProfile: async (createProfileRequestDto: CreateProfileRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProfileRequestDto' is not null or undefined
            assertParamExists('profileUserControllerCreateProfile', 'createProfileRequestDto', createProfileRequestDto)
            const localVarPath = `/v1/users/me/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProfileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update current user and his profile
         * @param {UpdateProfileRequestDto} updateProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileUserControllerUpdateProfile: async (updateProfileRequestDto: UpdateProfileRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProfileRequestDto' is not null or undefined
            assertParamExists('profileUserControllerUpdateProfile', 'updateProfileRequestDto', updateProfileRequestDto)
            const localVarPath = `/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ban a user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userBanControllerBanUser: async (userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userBanControllerBanUser', 'userId', userId)
            const localVarPath = `/v1/users/me/bans/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unban a user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userBanControllerUnbanUser: async (userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userBanControllerUnbanUser', 'userId', userId)
            const localVarPath = `/v1/users/me/bans/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete current user with his profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteUser: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all users with profiles
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [fullName] Find by name and surname
         * @param {string} [nickname] Find by nickname. Used exact compare
         * @param {string} [search] Find by name or surname or nickname
         * @param {string} [specializationId] 
         * @param {boolean} [celebritiesOnly] 
         * @param {'regDateAsc' | 'regDateDesc' | 'verifiedAsc' | 'verifiedDesc' | 'nameAsc' | 'nameDesc'} [sortMode] By default sorts by verified status(verified), then by registration date(newest first)
         * @param {'celebrities'} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAllUsers: async (afterCursor?: string, limit?: number, fullName?: string, nickname?: string, search?: string, specializationId?: string, celebritiesOnly?: boolean, sortMode?: 'regDateAsc' | 'regDateDesc' | 'verifiedAsc' | 'verifiedDesc' | 'nameAsc' | 'nameDesc', filter?: 'celebrities', options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (fullName !== undefined) {
                localVarQueryParameter['fullName'] = fullName;
            }

            if (nickname !== undefined) {
                localVarQueryParameter['nickname'] = nickname;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (specializationId !== undefined) {
                localVarQueryParameter['specializationId'] = specializationId;
            }

            if (celebritiesOnly !== undefined) {
                localVarQueryParameter['celebritiesOnly'] = celebritiesOnly;
            }

            if (sortMode !== undefined) {
                localVarQueryParameter['sortMode'] = sortMode;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current user and profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetMe: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user with profile
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUser: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerGetUser', 'id', id)
            const localVarPath = `/v1/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user ads with pagination. If requesting own ads, can filter by status (active/archived). If requesting other user ads, only active ads are returned.
         * @summary Get user ads (tasks) with pagination
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {'active' | 'archived'} [status] Filter user ads by status (active or archived). Only works when requesting own ads.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserAds: async (id: string, afterCursor?: string, limit?: number, status?: 'active' | 'archived', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userControllerGetUserAds', 'id', id)
            const localVarPath = `/v1/users/{id}/ads`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete fcm token
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFcmControllerDeleteFcmToken: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('userFcmControllerDeleteFcmToken', 'id', id)
            const localVarPath = `/v1/users/me/fcm-tokens/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get fcm tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFcmControllerGetFcmTokens: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/me/fcm-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add fcm token
         * @param {UserFcmTokenDto} userFcmTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFcmControllerPatchFcmToken: async (userFcmTokenDto: UserFcmTokenDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userFcmTokenDto' is not null or undefined
            assertParamExists('userFcmControllerPatchFcmToken', 'userFcmTokenDto', userFcmTokenDto)
            const localVarPath = `/v1/users/me/fcm-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userFcmTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete user from followers by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerDeleteFromFollowers: async (userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userFollowersControllerDeleteFromFollowers', 'userId', userId)
            const localVarPath = `/v1/users/me/followers/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Follow user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerFollowUser: async (userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userFollowersControllerFollowUser', 'userId', userId)
            const localVarPath = `/v1/users/me/following/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all current user followers
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [nickname] Find by nickname. Used exact compare
         * @param {string} [search] Find by name or surname or nickname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerGetUserFollowers: async (afterCursor?: string, limit?: number, nickname?: string, search?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/me/followers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nickname !== undefined) {
                localVarQueryParameter['nickname'] = nickname;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all current user following users
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [nickname] Find by nickname. Used exact compare
         * @param {string} [search] Find by name or surname or nickname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerGetUserFollowing: async (afterCursor?: string, limit?: number, nickname?: string, search?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/me/following`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (afterCursor !== undefined) {
                localVarQueryParameter['afterCursor'] = afterCursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nickname !== undefined) {
                localVarQueryParameter['nickname'] = nickname;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Is user followed by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerIsUserFollower: async (userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userFollowersControllerIsUserFollower', 'userId', userId)
            const localVarPath = `/v1/users/me/followers/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Is follow user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerIsUserFollowing: async (userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userFollowersControllerIsUserFollowing', 'userId', userId)
            const localVarPath = `/v1/users/me/following/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unfollow user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerUnfollowUser: async (userId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userFollowersControllerUnfollowUser', 'userId', userId)
            const localVarPath = `/v1/users/me/following/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get notification settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsSettingsControllerFindOneByUserId: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/me/notification-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch notification settings
         * @param {UpdateUserNotificationsSettingsRequestDto} updateUserNotificationsSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsSettingsControllerUpdateNotificationsSettings: async (updateUserNotificationsSettingsRequestDto: UpdateUserNotificationsSettingsRequestDto, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserNotificationsSettingsRequestDto' is not null or undefined
            assertParamExists('userNotificationsSettingsControllerUpdateNotificationsSettings', 'updateUserNotificationsSettingsRequestDto', updateUserNotificationsSettingsRequestDto)
            const localVarPath = `/v1/users/me/notification-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserNotificationsSettingsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1UsersApi - functional programming interface
 * @export
 */
export const V1UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create profile of the current user
         * @param {CreateProfileRequestDto} createProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileUserControllerCreateProfile(createProfileRequestDto: CreateProfileRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileUserControllerCreateProfile(createProfileRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update current user and his profile
         * @param {UpdateProfileRequestDto} updateProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileUserControllerUpdateProfile(updateProfileRequestDto: UpdateProfileRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateProfileResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileUserControllerUpdateProfile(updateProfileRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ban a user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userBanControllerBanUser(userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userBanControllerBanUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unban a user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userBanControllerUnbanUser(userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userBanControllerUnbanUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete current user with his profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerDeleteUser(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerDeleteUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all users with profiles
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [fullName] Find by name and surname
         * @param {string} [nickname] Find by nickname. Used exact compare
         * @param {string} [search] Find by name or surname or nickname
         * @param {string} [specializationId] 
         * @param {boolean} [celebritiesOnly] 
         * @param {'regDateAsc' | 'regDateDesc' | 'verifiedAsc' | 'verifiedDesc' | 'nameAsc' | 'nameDesc'} [sortMode] By default sorts by verified status(verified), then by registration date(newest first)
         * @param {'celebrities'} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetAllUsers(afterCursor?: string, limit?: number, fullName?: string, nickname?: string, search?: string, specializationId?: string, celebritiesOnly?: boolean, sortMode?: 'regDateAsc' | 'regDateDesc' | 'verifiedAsc' | 'verifiedDesc' | 'nameAsc' | 'nameDesc', filter?: 'celebrities', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUsersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetAllUsers(afterCursor, limit, fullName, nickname, search, specializationId, celebritiesOnly, sortMode, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get current user and profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetMe(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user with profile
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetUser(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get user ads with pagination. If requesting own ads, can filter by status (active/archived). If requesting other user ads, only active ads are returned.
         * @summary Get user ads (tasks) with pagination
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {'active' | 'archived'} [status] Filter user ads by status (active or archived). Only works when requesting own ads.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetUserAds(id: string, afterCursor?: string, limit?: number, status?: 'active' | 'archived', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetUserAds(id, afterCursor, limit, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary delete fcm token
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFcmControllerDeleteFcmToken(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFcmControllerDeleteFcmToken(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get fcm tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFcmControllerGetFcmTokens(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFcmControllerGetFcmTokens(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add fcm token
         * @param {UserFcmTokenDto} userFcmTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFcmControllerPatchFcmToken(userFcmTokenDto: UserFcmTokenDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserWithFcmsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFcmControllerPatchFcmToken(userFcmTokenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete user from followers by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFollowersControllerDeleteFromFollowers(userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFollowersControllerDeleteFromFollowers(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Follow user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFollowersControllerFollowUser(userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFollowersControllerFollowUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all current user followers
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [nickname] Find by nickname. Used exact compare
         * @param {string} [search] Find by name or surname or nickname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFollowersControllerGetUserFollowers(afterCursor?: string, limit?: number, nickname?: string, search?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFollowersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFollowersControllerGetUserFollowers(afterCursor, limit, nickname, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all current user following users
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [nickname] Find by nickname. Used exact compare
         * @param {string} [search] Find by name or surname or nickname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFollowersControllerGetUserFollowing(afterCursor?: string, limit?: number, nickname?: string, search?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFollowersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFollowersControllerGetUserFollowing(afterCursor, limit, nickname, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Is user followed by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFollowersControllerIsUserFollower(userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFollowersControllerIsUserFollower(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Is follow user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFollowersControllerIsUserFollowing(userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFollowersControllerIsUserFollowing(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unfollow user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFollowersControllerUnfollowUser(userId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFollowersControllerUnfollowUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get notification settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNotificationsSettingsControllerFindOneByUserId(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserNotificationsSettingsRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNotificationsSettingsControllerFindOneByUserId(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Patch notification settings
         * @param {UpdateUserNotificationsSettingsRequestDto} updateUserNotificationsSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNotificationsSettingsControllerUpdateNotificationsSettings(updateUserNotificationsSettingsRequestDto: UpdateUserNotificationsSettingsRequestDto, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserNotificationsSettingsRequestDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNotificationsSettingsControllerUpdateNotificationsSettings(updateUserNotificationsSettingsRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * V1UsersApi - factory interface
 * @export
 */
export const V1UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create profile of the current user
         * @param {CreateProfileRequestDto} createProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileUserControllerCreateProfile(createProfileRequestDto: CreateProfileRequestDto, options?: any): AxiosPromise<CreateProfileResponseDto> {
            return localVarFp.profileUserControllerCreateProfile(createProfileRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update current user and his profile
         * @param {UpdateProfileRequestDto} updateProfileRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileUserControllerUpdateProfile(updateProfileRequestDto: UpdateProfileRequestDto, options?: any): AxiosPromise<UpdateProfileResponseDto> {
            return localVarFp.profileUserControllerUpdateProfile(updateProfileRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ban a user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userBanControllerBanUser(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.userBanControllerBanUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unban a user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userBanControllerUnbanUser(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.userBanControllerUnbanUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete current user with his profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteUser(options?: any): AxiosPromise<void> {
            return localVarFp.userControllerDeleteUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all users with profiles
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [fullName] Find by name and surname
         * @param {string} [nickname] Find by nickname. Used exact compare
         * @param {string} [search] Find by name or surname or nickname
         * @param {string} [specializationId] 
         * @param {boolean} [celebritiesOnly] 
         * @param {'regDateAsc' | 'regDateDesc' | 'verifiedAsc' | 'verifiedDesc' | 'nameAsc' | 'nameDesc'} [sortMode] By default sorts by verified status(verified), then by registration date(newest first)
         * @param {'celebrities'} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAllUsers(afterCursor?: string, limit?: number, fullName?: string, nickname?: string, search?: string, specializationId?: string, celebritiesOnly?: boolean, sortMode?: 'regDateAsc' | 'regDateDesc' | 'verifiedAsc' | 'verifiedDesc' | 'nameAsc' | 'nameDesc', filter?: 'celebrities', options?: any): AxiosPromise<GetUsersResponseDto> {
            return localVarFp.userControllerGetAllUsers(afterCursor, limit, fullName, nickname, search, specializationId, celebritiesOnly, sortMode, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current user and profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetMe(options?: any): AxiosPromise<GetMeResponseDto> {
            return localVarFp.userControllerGetMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user with profile
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUser(id: string, options?: any): AxiosPromise<GetUserResponseDto> {
            return localVarFp.userControllerGetUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user ads with pagination. If requesting own ads, can filter by status (active/archived). If requesting other user ads, only active ads are returned.
         * @summary Get user ads (tasks) with pagination
         * @param {string} id 
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {'active' | 'archived'} [status] Filter user ads by status (active or archived). Only works when requesting own ads.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetUserAds(id: string, afterCursor?: string, limit?: number, status?: 'active' | 'archived', options?: any): AxiosPromise<void> {
            return localVarFp.userControllerGetUserAds(id, afterCursor, limit, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete fcm token
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFcmControllerDeleteFcmToken(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.userFcmControllerDeleteFcmToken(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get fcm tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFcmControllerGetFcmTokens(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.userFcmControllerGetFcmTokens(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add fcm token
         * @param {UserFcmTokenDto} userFcmTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFcmControllerPatchFcmToken(userFcmTokenDto: UserFcmTokenDto, options?: any): AxiosPromise<GetUserWithFcmsResponseDto> {
            return localVarFp.userFcmControllerPatchFcmToken(userFcmTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete user from followers by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerDeleteFromFollowers(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.userFollowersControllerDeleteFromFollowers(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Follow user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerFollowUser(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.userFollowersControllerFollowUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all current user followers
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [nickname] Find by nickname. Used exact compare
         * @param {string} [search] Find by name or surname or nickname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerGetUserFollowers(afterCursor?: string, limit?: number, nickname?: string, search?: string, options?: any): AxiosPromise<GetFollowersResponseDto> {
            return localVarFp.userFollowersControllerGetUserFollowers(afterCursor, limit, nickname, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all current user following users
         * @param {string} [afterCursor] 
         * @param {number} [limit] 
         * @param {string} [nickname] Find by nickname. Used exact compare
         * @param {string} [search] Find by name or surname or nickname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerGetUserFollowing(afterCursor?: string, limit?: number, nickname?: string, search?: string, options?: any): AxiosPromise<GetFollowersResponseDto> {
            return localVarFp.userFollowersControllerGetUserFollowing(afterCursor, limit, nickname, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Is user followed by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerIsUserFollower(userId: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.userFollowersControllerIsUserFollower(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Is follow user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerIsUserFollowing(userId: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.userFollowersControllerIsUserFollowing(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unfollow user by ID
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFollowersControllerUnfollowUser(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.userFollowersControllerUnfollowUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get notification settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsSettingsControllerFindOneByUserId(options?: any): AxiosPromise<GetUserNotificationsSettingsRequestDto> {
            return localVarFp.userNotificationsSettingsControllerFindOneByUserId(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch notification settings
         * @param {UpdateUserNotificationsSettingsRequestDto} updateUserNotificationsSettingsRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationsSettingsControllerUpdateNotificationsSettings(updateUserNotificationsSettingsRequestDto: UpdateUserNotificationsSettingsRequestDto, options?: any): AxiosPromise<GetUserNotificationsSettingsRequestDto> {
            return localVarFp.userNotificationsSettingsControllerUpdateNotificationsSettings(updateUserNotificationsSettingsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1UsersApi - object-oriented interface
 * @export
 * @class V1UsersApi
 * @extends {BaseAPI}
 */
export class V1UsersApi extends BaseAPI {
    /**
     * 
     * @summary Create profile of the current user
     * @param {CreateProfileRequestDto} createProfileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public profileUserControllerCreateProfile(createProfileRequestDto: CreateProfileRequestDto, options?: any) {
        return V1UsersApiFp(this.configuration).profileUserControllerCreateProfile(createProfileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update current user and his profile
     * @param {UpdateProfileRequestDto} updateProfileRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public profileUserControllerUpdateProfile(updateProfileRequestDto: UpdateProfileRequestDto, options?: any) {
        return V1UsersApiFp(this.configuration).profileUserControllerUpdateProfile(updateProfileRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ban a user by ID
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userBanControllerBanUser(userId: string, options?: any) {
        return V1UsersApiFp(this.configuration).userBanControllerBanUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unban a user by ID
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userBanControllerUnbanUser(userId: string, options?: any) {
        return V1UsersApiFp(this.configuration).userBanControllerUnbanUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete current user with his profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userControllerDeleteUser(options?: any) {
        return V1UsersApiFp(this.configuration).userControllerDeleteUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all users with profiles
     * @param {string} [afterCursor] 
     * @param {number} [limit] 
     * @param {string} [fullName] Find by name and surname
     * @param {string} [nickname] Find by nickname. Used exact compare
     * @param {string} [search] Find by name or surname or nickname
     * @param {string} [specializationId] 
     * @param {boolean} [celebritiesOnly] 
     * @param {'regDateAsc' | 'regDateDesc' | 'verifiedAsc' | 'verifiedDesc' | 'nameAsc' | 'nameDesc'} [sortMode] By default sorts by verified status(verified), then by registration date(newest first)
     * @param {'celebrities'} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userControllerGetAllUsers(afterCursor?: string, limit?: number, fullName?: string, nickname?: string, search?: string, specializationId?: string, celebritiesOnly?: boolean, sortMode?: 'regDateAsc' | 'regDateDesc' | 'verifiedAsc' | 'verifiedDesc' | 'nameAsc' | 'nameDesc', filter?: 'celebrities', options?: any) {
        return V1UsersApiFp(this.configuration).userControllerGetAllUsers(afterCursor, limit, fullName, nickname, search, specializationId, celebritiesOnly, sortMode, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current user and profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userControllerGetMe(options?: any) {
        return V1UsersApiFp(this.configuration).userControllerGetMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user with profile
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userControllerGetUser(id: string, options?: any) {
        return V1UsersApiFp(this.configuration).userControllerGetUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user ads with pagination. If requesting own ads, can filter by status (active/archived). If requesting other user ads, only active ads are returned.
     * @summary Get user ads (tasks) with pagination
     * @param {string} id 
     * @param {string} [afterCursor] 
     * @param {number} [limit] 
     * @param {'active' | 'archived'} [status] Filter user ads by status (active or archived). Only works when requesting own ads.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userControllerGetUserAds(id: string, afterCursor?: string, limit?: number, status?: 'active' | 'archived', options?: any) {
        return V1UsersApiFp(this.configuration).userControllerGetUserAds(id, afterCursor, limit, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete fcm token
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userFcmControllerDeleteFcmToken(id: string, options?: any) {
        return V1UsersApiFp(this.configuration).userFcmControllerDeleteFcmToken(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get fcm tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userFcmControllerGetFcmTokens(options?: any) {
        return V1UsersApiFp(this.configuration).userFcmControllerGetFcmTokens(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add fcm token
     * @param {UserFcmTokenDto} userFcmTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userFcmControllerPatchFcmToken(userFcmTokenDto: UserFcmTokenDto, options?: any) {
        return V1UsersApiFp(this.configuration).userFcmControllerPatchFcmToken(userFcmTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete user from followers by ID
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userFollowersControllerDeleteFromFollowers(userId: string, options?: any) {
        return V1UsersApiFp(this.configuration).userFollowersControllerDeleteFromFollowers(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Follow user by ID
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userFollowersControllerFollowUser(userId: string, options?: any) {
        return V1UsersApiFp(this.configuration).userFollowersControllerFollowUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all current user followers
     * @param {string} [afterCursor] 
     * @param {number} [limit] 
     * @param {string} [nickname] Find by nickname. Used exact compare
     * @param {string} [search] Find by name or surname or nickname
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userFollowersControllerGetUserFollowers(afterCursor?: string, limit?: number, nickname?: string, search?: string, options?: any) {
        return V1UsersApiFp(this.configuration).userFollowersControllerGetUserFollowers(afterCursor, limit, nickname, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all current user following users
     * @param {string} [afterCursor] 
     * @param {number} [limit] 
     * @param {string} [nickname] Find by nickname. Used exact compare
     * @param {string} [search] Find by name or surname or nickname
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userFollowersControllerGetUserFollowing(afterCursor?: string, limit?: number, nickname?: string, search?: string, options?: any) {
        return V1UsersApiFp(this.configuration).userFollowersControllerGetUserFollowing(afterCursor, limit, nickname, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Is user followed by ID
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userFollowersControllerIsUserFollower(userId: string, options?: any) {
        return V1UsersApiFp(this.configuration).userFollowersControllerIsUserFollower(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Is follow user by ID
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userFollowersControllerIsUserFollowing(userId: string, options?: any) {
        return V1UsersApiFp(this.configuration).userFollowersControllerIsUserFollowing(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unfollow user by ID
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userFollowersControllerUnfollowUser(userId: string, options?: any) {
        return V1UsersApiFp(this.configuration).userFollowersControllerUnfollowUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get notification settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userNotificationsSettingsControllerFindOneByUserId(options?: any) {
        return V1UsersApiFp(this.configuration).userNotificationsSettingsControllerFindOneByUserId(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch notification settings
     * @param {UpdateUserNotificationsSettingsRequestDto} updateUserNotificationsSettingsRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1UsersApi
     */
    public userNotificationsSettingsControllerUpdateNotificationsSettings(updateUserNotificationsSettingsRequestDto: UpdateUserNotificationsSettingsRequestDto, options?: any) {
        return V1UsersApiFp(this.configuration).userNotificationsSettingsControllerUpdateNotificationsSettings(updateUserNotificationsSettingsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}


